/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
}

export enum AdvisorSortEnum {
  Clients = 'CLIENTS',
  JobsAdded = 'JOBS_ADDED',
  JobsShared = 'JOBS_SHARED',
}

export type AdvisorUsers = {
  __typename?: 'AdvisorUsers'
  id: Scalars['ID']['output']
  jobsAdded: Array<UsersJobs>
  jobsShared: Array<UsersJobs>
  user: Users
}

export type AdvisoryOrganization = {
  __typename?: 'AdvisoryOrganization'
  brand: AdvisoryOrganizationBrand
  id: Scalars['ID']['output']
  members: Array<Users>
  name: Scalars['String']['output']
  subscriptionStatus: AdvisoryOrganizationSubscriptionStatusEnum
}

export type AdvisoryOrganizationBrand = {
  __typename?: 'AdvisoryOrganizationBrand'
  logoUrl: Scalars['String']['output']
}

export enum AdvisoryOrganizationSubscriptionStatusEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  PastDue = 'PAST_DUE',
  Trial = 'TRIAL',
}

export type AmIaGoodFit = {
  __typename?: 'AmIAGoodFit'
  overallMatch?: Maybe<UsersJobsMatchEnum>
  overallSummary?: Maybe<Scalars['String']['output']>
  relevantEducation?: Maybe<Scalars['String']['output']>
  relevantEducationMatch?: Maybe<Scalars['Boolean']['output']>
  relevantExperience?: Maybe<Scalars['String']['output']>
  relevantExperienceMatch?: Maybe<Scalars['Boolean']['output']>
  relevantSkills?: Maybe<Scalars['String']['output']>
  relevantSkillsMatch?: Maybe<Scalars['Boolean']['output']>
}

export enum AuthProviderTypeEnum {
  Google = 'GOOGLE',
}

export type AuthResponse = {
  __typename?: 'AuthResponse'
  isNewUser?: Maybe<Scalars['Boolean']['output']>
  token?: Maybe<Scalars['ID']['output']>
  user?: Maybe<Users>
}

export type CachedStreamingType = {
  __typename?: 'CachedStreamingType'
  isSync: Scalars['Boolean']['output']
  result: Scalars['String']['output']
}

export type CareerPathsPostType = {
  __typename?: 'CareerPathsPostType'
  category?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
}

export type ClientGroup = {
  __typename?: 'ClientGroup'
  clients: Array<ClientUsers>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByUser: Users
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ClientUsers = {
  __typename?: 'ClientUsers'
  addedJobs: Array<UsersJobs>
  allJobs: Array<UsersJobs>
  appliedJobs: Array<UsersJobs>
  id: Scalars['ID']['output']
  interviewedJobs: Array<UsersJobs>
  numAddedJobs: Scalars['Int']['output']
  numAllJobs: Scalars['Int']['output']
  numAppliedJobs: Scalars['Int']['output']
  numInterviewedJobs: Scalars['Int']['output']
  numOfferedJobs: Scalars['Int']['output']
  numRejectedJobs: Scalars['Int']['output']
  offeredJobs: Array<UsersJobs>
  rejectedJobs: Array<UsersJobs>
  user: Users
}

export type CompanyAboutInfo = {
  __typename?: 'CompanyAboutInfo'
  companyLogo?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  foundedYear?: Maybe<Scalars['Int']['output']>
  industry?: Maybe<Scalars['String']['output']>
  linkedinCompanyUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  numberOfEmployeeRangeMax?: Maybe<Scalars['Int']['output']>
  numberOfEmployeeRangeMin?: Maybe<Scalars['Int']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
}

export type CompanyLatestInfo = {
  __typename?: 'CompanyLatestInfo'
  accomplishmentsAndAnnouncementsAndProductReleases?: Maybe<Array<CompanyLatestInfoSource>>
  companyCultureAndPractices?: Maybe<Scalars['String']['output']>
  competitors?: Maybe<Array<CompanyLatestInfoCompetitors>>
  expectedSalaryMessage?: Maybe<Scalars['String']['output']>
  fundingsRounds?: Maybe<Array<CompanyLatestInfoSource>>
  growthFinancialNumbers?: Maybe<Array<CompanyLatestInfoSource>>
  maximumSalary?: Maybe<Scalars['Int']['output']>
  minimumSalary?: Maybe<Scalars['Int']['output']>
  missionAndVisionOfCompany?: Maybe<Scalars['String']['output']>
}

export type CompanyLatestInfoCompetitors = {
  __typename?: 'CompanyLatestInfoCompetitors'
  name: Scalars['String']['output']
  website: Scalars['String']['output']
}

export type CompanyLatestInfoSource = {
  __typename?: 'CompanyLatestInfoSource'
  description: Scalars['String']['output']
  source: Scalars['String']['output']
}

export type Contacts = {
  __typename?: 'Contacts'
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type ContactsInputObject = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
}

export enum CoverLetterLengthEnum {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT',
}

export enum CoverLetterToneEnum {
  Casual = 'CASUAL',
  Excited = 'EXCITED',
  Formal = 'FORMAL',
  Informational = 'INFORMATIONAL',
}

export enum FakeJobConcernLevelEnum {
  High = 'HIGH',
  None = 'NONE',
  Some = 'SOME',
}

export type FakeJobInfo = {
  __typename?: 'FakeJobInfo'
  fakeJobConcernLevel: FakeJobConcernLevelEnum
  glassdoorRating?: Maybe<Scalars['Float']['output']>
  glassdoorRatingConcernLevel: FakeJobConcernLevelEnum
  jobPostingDateConcernLevel: FakeJobConcernLevelEnum
  overallConcernLevel: FakeJobConcernLevelEnum
}

export type FieldMessageType = {
  __typename?: 'FieldMessageType'
  errorMessage?: Maybe<Scalars['String']['output']>
  field: Scalars['String']['output']
}

/** Autogenerated return type of FormFieldsMapping. */
export type FormFieldsMappingPayload = {
  __typename?: 'FormFieldsMappingPayload'
  content: Scalars['String']['output']
  final: Scalars['Boolean']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
}

export type FormFieldsValueMapping = {
  __typename?: 'FormFieldsValueMapping'
  htmlSelector?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of GlassdoorResults. */
export type GlassdoorResultsPayload = {
  __typename?: 'GlassdoorResultsPayload'
  initial: Scalars['Boolean']['output']
  rating?: Maybe<Scalars['Float']['output']>
  requestId: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
  usersJobId: Scalars['ID']['output']
  whatConsUsersAreSaying?: Maybe<Scalars['String']['output']>
  whatConsUsersAreSayingAboutPosition?: Maybe<Scalars['String']['output']>
  whatProsUsersAreSaying?: Maybe<Scalars['String']['output']>
  whatProsUsersAreSayingAboutPosition?: Maybe<Scalars['String']['output']>
}

export type HeadshotRequest = {
  __typename?: 'HeadshotRequest'
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  picturesUrl: Array<Scalars['String']['output']>
  status: HeadshotRequestsStatusEnum
}

export enum HeadshotRequestsAttireEnum {
  BusinessCasual = 'BUSINESS_CASUAL',
  BusinessProfessional = 'BUSINESS_PROFESSIONAL',
  SmartCasual = 'SMART_CASUAL',
}

export enum HeadshotRequestsBackgroundEnum {
  City = 'CITY',
  Nature = 'NATURE',
  Office = 'OFFICE',
  Studio = 'STUDIO',
}

export enum HeadshotRequestsStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}

export type Interview = {
  __typename?: 'Interview'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  interviewType: InterviewsTypeEnum
  jobTitle: Scalars['String']['output']
  messages: Array<InterviewsMessage>
  score?: Maybe<Scalars['Int']['output']>
  status: InterviewsStatusEnum
}

export type InterviewQuestionsPostType = {
  __typename?: 'InterviewQuestionsPostType'
  category?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
}

export type InterviewsMessage = {
  __typename?: 'InterviewsMessage'
  fromUser: Scalars['Boolean']['output']
  message: Scalars['String']['output']
}

export enum InterviewsStatusEnum {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Started = 'STARTED',
}

export enum InterviewsTypeEnum {
  IntroRecruiterScreen = 'INTRO_RECRUITER_SCREEN',
  JobInterviewBehavioralTechnical = 'JOB_INTERVIEW_BEHAVIORAL_TECHNICAL',
}

export enum JobListingDatePostedEnum {
  Last_1Day = 'LAST_1_DAY',
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
}

export enum JobListingEducationLevelEnum {
  AssociateDegree = 'ASSOCIATE_DEGREE',
  BachelorDegree = 'BACHELOR_DEGREE',
  HighSchool = 'HIGH_SCHOOL',
  PostgraduateDegree = 'POSTGRADUATE_DEGREE',
  ProfessionalCertificate = 'PROFESSIONAL_CERTIFICATE',
}

export enum JobListingEmploymentTypeEnum {
  Contractor = 'CONTRACTOR',
  FullTime = 'FULL_TIME',
  Intern = 'INTERN',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM',
  Temporary = 'TEMPORARY',
  Volunteer = 'VOLUNTEER',
}

export enum JobListingExperienceLevelEnum {
  DirectorLevel = 'DIRECTOR_LEVEL',
  EntryLevel = 'ENTRY_LEVEL',
  ExecutiveLevel = 'EXECUTIVE_LEVEL',
  InternshipLevel = 'INTERNSHIP_LEVEL',
  MidLevel = 'MID_LEVEL',
  SeniorLevel = 'SENIOR_LEVEL',
}

export enum JobListingFoundedDateEnum {
  Last_1Year = 'LAST_1_YEAR',
  Last_3Months = 'LAST_3_MONTHS',
  Last_3Years = 'LAST_3_YEARS',
  Last_5Years = 'LAST_5_YEARS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_10Years = 'LAST_10_YEARS',
}

export enum JobListingPayPeriodEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type JobListingSavedSearch = {
  __typename?: 'JobListingSavedSearch'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  searchFilters: JobListingsFilter
}

export enum JobListingWorkArrangementEnum {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  RemoteOk = 'REMOTE_OK',
  RemoteSolely = 'REMOTE_SOLELY',
}

export type JobListings = {
  __typename?: 'JobListings'
  aiCoreResponsibilities?: Maybe<Scalars['String']['output']>
  aiEducationRequirements?: Maybe<Array<JobListingEducationLevelEnum>>
  aiKeywords?: Maybe<Array<Scalars['String']['output']>>
  aiRequirementsSummary?: Maybe<Scalars['String']['output']>
  aiTaxonomiesA?: Maybe<Array<Scalars['String']['output']>>
  aiWorkArrangement?: Maybe<JobListingWorkArrangementEnum>
  benefits: Array<Scalars['String']['output']>
  companyDescription?: Maybe<Scalars['String']['output']>
  companyDomain?: Maybe<Scalars['String']['output']>
  companyIndustry?: Maybe<Scalars['String']['output']>
  companyLinkedinUrl?: Maybe<Scalars['String']['output']>
  companyLogoUrl?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  companyNumEmployees?: Maybe<Scalars['Int']['output']>
  companySpecialties: Array<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  datePosted: Scalars['ISO8601DateTime']['output']
  employmentType?: Maybe<JobListingEmploymentTypeEnum>
  employmentTypes: Array<JobListingEmploymentTypeEnum>
  experienceLevelMax?: Maybe<Scalars['Int']['output']>
  experienceLevelMin?: Maybe<Scalars['Int']['output']>
  experienceLevelString?: Maybe<Scalars['String']['output']>
  expired: Scalars['Boolean']['output']
  externalApplyUrl?: Maybe<Scalars['String']['output']>
  hiringManagerEmail?: Maybe<Scalars['String']['output']>
  hiringManagerName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isRemote?: Maybe<Scalars['Boolean']['output']>
  jobDetails?: Maybe<Scalars['String']['output']>
  keySkills: Array<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  position: Scalars['String']['output']
  salaryCurrency?: Maybe<Scalars['String']['output']>
  salaryMax?: Maybe<Scalars['Int']['output']>
  salaryMin?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
  visaSponsorship: Scalars['Boolean']['output']
  workingHours?: Maybe<Scalars['Int']['output']>
}

export type JobListingsFilter = {
  __typename?: 'JobListingsFilter'
  companyName?: Maybe<Scalars['String']['output']>
  companyNumEmployeesMax?: Maybe<Scalars['Int']['output']>
  companyNumEmployeesMin?: Maybe<Scalars['Int']['output']>
  datePosted?: Maybe<JobListingDatePostedEnum>
  datePostedMax?: Maybe<Scalars['ISO8601DateTime']['output']>
  datePostedMin?: Maybe<Scalars['ISO8601DateTime']['output']>
  educationRequirements?: Maybe<Array<JobListingEducationLevelEnum>>
  employmentTypes?: Maybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevelMax?: Maybe<Scalars['Int']['output']>
  experienceLevelMin?: Maybe<Scalars['Int']['output']>
  experienceLevels?: Maybe<Array<JobListingExperienceLevelEnum>>
  foundedDate?: Maybe<JobListingFoundedDateEnum>
  keywordOr?: Maybe<Scalars['Boolean']['output']>
  keywords?: Maybe<Array<Scalars['String']['output']>>
  locations?: Maybe<Array<JobListingsLocation>>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  positions?: Maybe<Array<Scalars['String']['output']>>
  salaryMin?: Maybe<Scalars['Int']['output']>
  skills?: Maybe<Array<Scalars['String']['output']>>
  taxonomies?: Maybe<Array<Scalars['String']['output']>>
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workArrangements?: Maybe<Array<JobListingWorkArrangementEnum>>
}

export type JobListingsFilterInputObject = {
  companyName?: InputMaybe<Scalars['String']['input']>
  companyNumEmployeesMax?: InputMaybe<Scalars['Int']['input']>
  companyNumEmployeesMin?: InputMaybe<Scalars['Int']['input']>
  datePosted?: InputMaybe<JobListingDatePostedEnum>
  datePostedMax?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  datePostedMin?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  educationRequirements?: InputMaybe<Array<JobListingEducationLevelEnum>>
  employmentTypes?: InputMaybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevelMax?: InputMaybe<Scalars['Int']['input']>
  experienceLevelMin?: InputMaybe<Scalars['Int']['input']>
  experienceLevels?: InputMaybe<Array<JobListingExperienceLevelEnum>>
  foundedDate?: InputMaybe<JobListingFoundedDateEnum>
  keywordOr?: InputMaybe<Scalars['Boolean']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  locations?: InputMaybe<Array<JobListingsLocationInputObject>>
  payPeriod?: InputMaybe<JobListingPayPeriodEnum>
  positions?: InputMaybe<Array<Scalars['String']['input']>>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workArrangements?: InputMaybe<Array<JobListingWorkArrangementEnum>>
}

export type JobListingsLocation = {
  __typename?: 'JobListingsLocation'
  location: Scalars['String']['output']
  radius?: Maybe<Scalars['Int']['output']>
  useCityStateForLocation?: Maybe<Scalars['Boolean']['output']>
}

export type JobListingsLocationInputObject = {
  location: Scalars['String']['input']
  radius?: InputMaybe<Scalars['Int']['input']>
  useCityStateForLocation?: InputMaybe<Scalars['Boolean']['input']>
}

export enum JobListingsSortEnum {
  DatePosted = 'DATE_POSTED',
}

export enum JobPostingSortEnum {
  ClientsApplied = 'CLIENTS_APPLIED',
  ClientsSharedWith = 'CLIENTS_SHARED_WITH',
}

export type JobSearchPreference = {
  __typename?: 'JobSearchPreference'
  companyNumEmployeesMax?: Maybe<Scalars['Int']['output']>
  companyNumEmployeesMin?: Maybe<Scalars['Int']['output']>
  datePosted?: Maybe<JobListingDatePostedEnum>
  educationRequirement?: Maybe<JobListingEducationLevelEnum>
  employmentTypes?: Maybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevels?: Maybe<Array<JobListingExperienceLevelEnum>>
  keywords?: Maybe<Array<Scalars['String']['output']>>
  locations?: Maybe<Array<Scalars['String']['output']>>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  positions?: Maybe<Array<Scalars['String']['output']>>
  salaryMin?: Maybe<Scalars['Int']['output']>
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workArrangements?: Maybe<Array<JobListingWorkArrangementEnum>>
}

export type JobSearchPreferenceInputObject = {
  companyNumEmployeesMax?: InputMaybe<Scalars['Int']['input']>
  companyNumEmployeesMin?: InputMaybe<Scalars['Int']['input']>
  datePosted?: InputMaybe<JobListingDatePostedEnum>
  educationRequirement?: InputMaybe<JobListingEducationLevelEnum>
  employmentTypes?: InputMaybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevels?: InputMaybe<Array<JobListingExperienceLevelEnum>>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  locations?: InputMaybe<Array<Scalars['String']['input']>>
  payPeriod?: InputMaybe<JobListingPayPeriodEnum>
  positions?: InputMaybe<Array<Scalars['String']['input']>>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workArrangements?: InputMaybe<Array<JobListingWorkArrangementEnum>>
}

/** Autogenerated return type of LearnSkills. */
export type LearnSkillsPayload = {
  __typename?: 'LearnSkillsPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
  usersJobId: Scalars['ID']['output']
}

export type LinkedinCompany = {
  __typename?: 'LinkedinCompany'
  name: Scalars['String']['output']
  profilePicUrl?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export enum MessagesContactType {
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER',
  SimilarTitle = 'SIMILAR_TITLE',
}

export enum MessagesMessageType {
  FollowUpEmail = 'FOLLOW_UP_EMAIL',
  JobOutreach = 'JOB_OUTREACH',
  Networking = 'NETWORKING',
  ReferralRequest = 'REFERRAL_REQUEST',
  ThankYouPostInterview = 'THANK_YOU_POST_INTERVIEW',
}

export type Mutation = {
  __typename?: 'Mutation'
  addContactToUsersJob: UsersJobs
  addUsersToClientGroup: ClientGroup
  amIAGoodFit?: Maybe<AmIaGoodFit>
  assignClientToAdvisor: Scalars['String']['output']
  authPasswordResetRequest: Scalars['String']['output']
  authProviderAuthenticate: AuthResponse
  authResetPassword: Scalars['String']['output']
  authSignIn: AuthResponse
  authSignUp: AuthResponse
  billingPortalUrl: Scalars['String']['output']
  bookmarkJob: UsersJobs
  coverLetterBodyPrefillApplication: Scalars['String']['output']
  coverLetterUpsert: UsersJobsCoverLetterType
  createClientGroup: ClientGroup
  createFeedback: Scalars['String']['output']
  createHeadshotRequest: HeadshotRequest
  createResume: Resumes
  createResumeFromLinkedinUrl: Resumes
  createResumeUnauthenticated: Resumes
  createSearchFilter: JobListingSavedSearch
  createUsersJob: UsersJobs
  createWritingSample: Scalars['String']['output']
  downloadPdfResume: Resumes
  duplicateResume: Resumes
  duplicateResumeFromResumeExample: Resumes
  editClientGroup: ClientGroup
  exportUsersJobToCsv: Scalars['String']['output']
  fakeJobMutation: FakeJobInfo
  fetchJobKeywords: Array<Scalars['String']['output']>
  fetchMissingSkillsOfJobResume: Array<Scalars['String']['output']>
  fixFromRelevanceAnalysis: Resumes
  generateCompanyDomain: UsersJobs
  generateCoverLetter: UsersJobsCoverLetterType
  generateDraftEmailForSimilarProfile: SimilarProfilesMessage
  generateJobAchievement: Array<Scalars['String']['output']>
  generateJobAchievementFromString: Array<Scalars['String']['output']>
  generateMessageForContact: SimilarProfilesMessage
  generateOneJobAchievement: Scalars['String']['output']
  generateProfessionalSummary: Scalars['String']['output']
  interviewAddMessage: Interview
  interviewStartMock: Interview
  inviteAdvisor?: Maybe<Users>
  inviteClient?: Maybe<Users>
  jobsFormFieldsMapping: Array<FormFieldsValueMapping>
  jobsFormFieldsMappingV2: Scalars['String']['output']
  learnSkills: CachedStreamingType
  manuallyReportGhostJob: Scalars['String']['output']
  markJobListingAsApplied: UsersJobs
  matchScore: UsersJobsMatch
  optimizeResumeForJob: Resumes
  optimizeResumeForJobV2: Resumes
  previewAuthResume: Scalars['String']['output']
  previewResume: Scalars['String']['output']
  questionPrefillApplication: Scalars['String']['output']
  requestResumeReview: Scalars['String']['output']
  resumeRecentUploaded?: Maybe<Resumes>
  resumeRelevanceAnalysis: ResumesResumeRelevanceAnalysis
  roastResume: Scalars['String']['output']
  salaryInsights: Scalars['String']['output']
  sampleInterviewQuestions: CachedStreamingType
  scoreResume: ResumesScoreType
  shareJobWithClients: UsersJobs
  subscriptionsRedeemLtdPromoCode: Users
  subscriptionsRequestResumeSuccess: Scalars['String']['output']
  subscriptionsSessionCreate: Scalars['String']['output']
  subscriptionsSessionFetch: Scalars['String']['output']
  unbookmarkJob: UsersJobs
  updateAdvisoryOrganization: Users
  updateArchivedCoverLetter: UsersJobsCoverLetterType
  updateArchivedResume: Resumes
  updateLastPageLoadedAt: Users
  updatePdfBlob: Resumes
  updatePublicResume: Resumes
  updateResume: Resumes
  updateResumePreferences: Resumes
  updateResumeUnauthenticated: Resumes
  updateSearchFilter: JobListingSavedSearch
  updateShowOriginalDocumentResume: Resumes
  updateTemplateResume: Resumes
  updateUser: Users
  updateUsersJob: UsersJobs
  updateWritingSample: WritingSample
  uploadResume: Resumes
  uploadResumeWebsocket: Scalars['String']['output']
  usedChromeExtension: Scalars['String']['output']
  userEmailVerify: AuthResponse
  userStoreLocation: Users
  userUpdateWritingStyle: Users
  userUploadProfilePicture: Users
  userUpsertJobSearchPreference: JobSearchPreference
}

export type MutationAddContactToUsersJobArgs = {
  contact: ContactsInputObject
  id: Scalars['ID']['input']
}

export type MutationAddUsersToClientGroupArgs = {
  clientGroupId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']>
}

export type MutationAmIaGoodFitArgs = {
  jobDescription?: InputMaybe<Scalars['String']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationAssignClientToAdvisorArgs = {
  advisorId: Scalars['ID']['input']
  clientIds: Array<Scalars['ID']['input']>
}

export type MutationAuthPasswordResetRequestArgs = {
  email: Scalars['String']['input']
}

export type MutationAuthProviderAuthenticateArgs = {
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
}

export type MutationAuthResetPasswordArgs = {
  newPassword: Scalars['String']['input']
  resetPasswordToken: Scalars['String']['input']
}

export type MutationAuthSignInArgs = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationAuthSignUpArgs = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
}

export type MutationBookmarkJobArgs = {
  jobListingId: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}

export type MutationCoverLetterBodyPrefillApplicationArgs = {
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationCoverLetterUpsertArgs = {
  attributes: UsersJobsCoverLetterInputObject
  usersJobId: Scalars['ID']['input']
}

export type MutationCreateClientGroupArgs = {
  name: Scalars['String']['input']
}

export type MutationCreateFeedbackArgs = {
  feedback: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateHeadshotRequestArgs = {
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  uploadSignedId: Array<Scalars['ID']['input']>
}

export type MutationCreateResumeArgs = {
  name: Scalars['String']['input']
}

export type MutationCreateResumeFromLinkedinUrlArgs = {
  linkedinProfileUrl: Scalars['String']['input']
}

export type MutationCreateResumeUnauthenticatedArgs = {
  attributes?: InputMaybe<ResumesInputObject>
}

export type MutationCreateSearchFilterArgs = {
  name: Scalars['String']['input']
  searchFilters: JobListingsFilterInputObject
}

export type MutationCreateUsersJobArgs = {
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  companyName: Scalars['String']['input']
  contact?: InputMaybe<ContactsInputObject>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position: Scalars['String']['input']
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  uniqueUrl?: InputMaybe<Scalars['Boolean']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateWritingSampleArgs = {
  answer: Scalars['String']['input']
  question: Scalars['String']['input']
}

export type MutationDownloadPdfResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationDuplicateResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationDuplicateResumeFromResumeExampleArgs = {
  id: Scalars['ID']['input']
}

export type MutationEditClientGroupArgs = {
  clientGroupId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationFakeJobMutationArgs = {
  companyName: Scalars['String']['input']
  datePosted?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationFetchJobKeywordsArgs = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationFetchMissingSkillsOfJobResumeArgs = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationFixFromRelevanceAnalysisArgs = {
  achievementsToUpdate?: InputMaybe<Array<ResumesRelevantAchievementInputObject>>
  id: Scalars['ID']['input']
  skillsToAdd?: InputMaybe<Array<Scalars['String']['input']>>
  skillsToRemove?: InputMaybe<Array<ResumesAnalysisSkillTypeInputObject>>
  summary?: InputMaybe<Scalars['String']['input']>
}

export type MutationGenerateCompanyDomainArgs = {
  id: Scalars['ID']['input']
}

export type MutationGenerateCoverLetterArgs = {
  coverLetterLength?: InputMaybe<CoverLetterLengthEnum>
  coverLetterTone?: InputMaybe<CoverLetterToneEnum>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationGenerateDraftEmailForSimilarProfileArgs = {
  forHiringManager?: InputMaybe<Scalars['Boolean']['input']>
  forRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  resumeId: Scalars['ID']['input']
  similarProfile: SimilarProfilesInputObject
  usersJobId: Scalars['ID']['input']
}

export type MutationGenerateJobAchievementArgs = {
  indices: Array<Scalars['Int']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  workPositionId: Scalars['ID']['input']
}

export type MutationGenerateJobAchievementFromStringArgs = {
  achievementStrings: Array<Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationGenerateMessageForContactArgs = {
  companyName: Scalars['String']['input']
  contactName: Scalars['String']['input']
  contactRelationship: MessagesContactType
  jobTitle: Scalars['String']['input']
  messageType: MessagesMessageType
}

export type MutationGenerateOneJobAchievementArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>
  index: Scalars['Int']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  workPositionId: Scalars['ID']['input']
}

export type MutationGenerateProfessionalSummaryArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  useExisting: Scalars['Boolean']['input']
}

export type MutationInterviewAddMessageArgs = {
  interviewId: Scalars['String']['input']
  message: Scalars['String']['input']
}

export type MutationInterviewStartMockArgs = {
  interviewType: InterviewsTypeEnum
  jobDescription?: InputMaybe<Scalars['String']['input']>
  jobTitle: Scalars['String']['input']
  resumeId?: InputMaybe<Scalars['ID']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationInviteAdvisorArgs = {
  email: Scalars['String']['input']
  role: UsersRoleEnum
}

export type MutationInviteClientArgs = {
  email: Scalars['String']['input']
}

export type MutationJobsFormFieldsMappingArgs = {
  extraDataSource?: InputMaybe<Scalars['String']['input']>
  htmlString: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationJobsFormFieldsMappingV2Args = {
  extraDataSource?: InputMaybe<Scalars['String']['input']>
  htmlString: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationLearnSkillsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationManuallyReportGhostJobArgs = {
  companyName: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type MutationMarkJobListingAsAppliedArgs = {
  jobListingId: Scalars['ID']['input']
}

export type MutationMatchScoreArgs = {
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationOptimizeResumeForJobArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  usersJobId: Scalars['ID']['input']
}

export type MutationOptimizeResumeForJobV2Args = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationPreviewAuthResumeArgs = {
  id: Scalars['ID']['input']
  template: ResumesTemplateEnum
}

export type MutationPreviewResumeArgs = {
  attributes: ResumesInputObject
  template: ResumesTemplateEnum
}

export type MutationQuestionPrefillApplicationArgs = {
  question: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationRequestResumeReviewArgs = {
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type MutationResumeRelevanceAnalysisArgs = {
  id: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
}

export type MutationRoastResumeArgs = {
  jobTitle: Scalars['String']['input']
  roleType: RoastRoleTypeEnum
  token: Scalars['String']['input']
  toneLevel: RoastToneLevelEnum
  uploadSignedId: Scalars['ID']['input']
}

export type MutationSalaryInsightsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationSampleInterviewQuestionsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationScoreResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationShareJobWithClientsArgs = {
  clientGroupIds: Array<Scalars['ID']['input']>
  userIds: Array<Scalars['ID']['input']>
  usersJobId: Scalars['ID']['input']
}

export type MutationSubscriptionsRedeemLtdPromoCodeArgs = {
  promoCode: Scalars['String']['input']
}

export type MutationSubscriptionsRequestResumeSuccessArgs = {
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
}

export type MutationSubscriptionsSessionCreateArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  plan: SubscriptionPlanEnum
}

export type MutationSubscriptionsSessionFetchArgs = {
  sessionId: Scalars['ID']['input']
}

export type MutationUnbookmarkJobArgs = {
  jobListingId: Scalars['ID']['input']
}

export type MutationUpdateAdvisoryOrganizationArgs = {
  name: Scalars['String']['input']
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationUpdateArchivedCoverLetterArgs = {
  archived: Scalars['Boolean']['input']
  coverLetterId: Scalars['ID']['input']
}

export type MutationUpdateArchivedResumeArgs = {
  archived: Scalars['Boolean']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdatePdfBlobArgs = {
  id: Scalars['ID']['input']
  pdfBlob: Array<Scalars['Int']['input']>
}

export type MutationUpdatePublicResumeArgs = {
  id: Scalars['ID']['input']
  isPublic: Scalars['Boolean']['input']
}

export type MutationUpdateResumeArgs = {
  attributes: ResumesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateResumePreferencesArgs = {
  attributes: ResumePreferencesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateResumeUnauthenticatedArgs = {
  attributes: ResumesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateSearchFilterArgs = {
  id: Scalars['ID']['input']
  searchFilters: JobListingsFilterInputObject
}

export type MutationUpdateShowOriginalDocumentResumeArgs = {
  id: Scalars['ID']['input']
  showOriginalDocument: Scalars['Boolean']['input']
}

export type MutationUpdateTemplateResumeArgs = {
  id: Scalars['ID']['input']
  template: ResumesTemplateEnum
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
}

export type MutationUpdateUserArgs = {
  attributes: UsersInputObject
}

export type MutationUpdateUsersJobArgs = {
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  appliedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  appliedChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  interviewChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position?: InputMaybe<Scalars['String']['input']>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  url?: InputMaybe<Scalars['String']['input']>
  wishlistChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
}

export type MutationUpdateWritingSampleArgs = {
  answer?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type MutationUploadResumeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUploadResumeWebsocketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUserEmailVerifyArgs = {
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationUserStoreLocationArgs = {
  city: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationUserUpdateWritingStyleArgs = {
  writingStyleEnum: UsersWritingStyleEnum
}

export type MutationUserUploadProfilePictureArgs = {
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUserUpsertJobSearchPreferenceArgs = {
  attributes?: InputMaybe<JobSearchPreferenceInputObject>
}

/** Autogenerated return type of OcrResume. */
export type OcrResumePayload = {
  __typename?: 'OcrResumePayload'
  resumeId: Scalars['ID']['output']
}

export type PaginatedAdvisorUsers = {
  __typename?: 'PaginatedAdvisorUsers'
  data: Array<AdvisorUsers>
  pagination: Pagination
}

export type PaginatedClientUsers = {
  __typename?: 'PaginatedClientUsers'
  data: Array<ClientUsers>
  pagination: Pagination
}

export type PaginatedJobListings = {
  __typename?: 'PaginatedJobListings'
  data: Array<JobListings>
  pagination: Pagination
}

export type PaginatedResumeExamples = {
  __typename?: 'PaginatedResumeExamples'
  data: Array<Resumes>
  pagination: Pagination
}

export type PaginatedUsersJobs = {
  __typename?: 'PaginatedUsersJobs'
  data: Array<UsersJobs>
  pagination: Pagination
}

export type Pagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ProfileMatchSimilarProfile = {
  __typename?: 'ProfileMatchSimilarProfile'
  matchTypes: Array<SimilarProfilesMatchTypeEnum>
  profile: SimilarProfiles
}

export type Query = {
  __typename?: 'Query'
  advisors: PaginatedAdvisorUsers
  client: Users
  clientGroups: Array<ClientGroup>
  clientResumes: Array<Resumes>
  clientUsersJobs: Array<UsersJobs>
  clients: PaginatedClientUsers
  coverLetterExample?: Maybe<UsersJobsCoverLetterType>
  coverLetterExamples?: Maybe<Array<UsersJobsCoverLetterType>>
  coverLetters: Array<UsersJobsCoverLetterType>
  emailVerifyAllowed?: Maybe<Users>
  fakeJob: FakeJobInfo
  findUsersJobByInfo?: Maybe<UsersJobs>
  findUsersJobByUrl?: Maybe<UsersJobs>
  getAboutCompanyInfo?: Maybe<CompanyAboutInfo>
  getGlassdoorResults: Scalars['String']['output']
  getLatestCompanyInfo?: Maybe<CompanyLatestInfo>
  getLinkedinConnectionsUrl: Scalars['String']['output']
  getPossibleLinkedinCompany: LinkedinCompany
  hasAddedJobListing?: Maybe<UsersJobs>
  headshotRequests: Array<HeadshotRequest>
  hiringManagersFromUsersJob: Array<SimilarProfiles>
  interviews: Array<Interview>
  jobListing: JobListings
  jobSearchPreference: JobSearchPreference
  locationsTypeahead: Array<Scalars['String']['output']>
  networkingPeopleFromUsersJob: Array<ProfileMatchSimilarProfile>
  paginatedJobListings: PaginatedJobListings
  paginatedResumeExamples: PaginatedResumeExamples
  paginatedUsersJobs: PaginatedUsersJobs
  publicResume?: Maybe<Resumes>
  resetPasswordAllowed: Scalars['Boolean']['output']
  resumeExample?: Maybe<Resumes>
  resumeExampleCategories?: Maybe<Array<Scalars['String']['output']>>
  resumeExamples?: Maybe<Array<Resumes>>
  resumeScore: ResumesScoreType
  resumeSimpleAnalysis: Array<FieldMessageType>
  resumeUnauthenticated?: Maybe<Resumes>
  resumes: Array<Resumes>
  resumesPdfBlob: Scalars['String']['output']
  sameEducationProfilesFromUsersJob: Array<SimilarProfiles>
  similarCareerPaths?: Maybe<Array<CareerPathsPostType>>
  similarCoverLetterExamples?: Maybe<Array<UsersJobsCoverLetterType>>
  similarInterviewQuestions?: Maybe<Array<InterviewQuestionsPostType>>
  similarProfilesFromUsersJob: Array<SimilarProfiles>
  similarResumeExamples?: Maybe<Array<Resumes>>
  user: Users
  usersJobs: Array<UsersJobs>
  usersJobsDateRange: UsersJobsPerformanceDateRange
  writingSamples: Array<WritingSample>
}

export type QueryAdvisorsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  role?: InputMaybe<UsersRoleEnum>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<AdvisorSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryClientArgs = {
  clientId: Scalars['ID']['input']
}

export type QueryClientGroupsArgs = {
  clientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientResumesArgs = {
  clientId: Scalars['ID']['input']
  resumeIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  clientId: Scalars['ID']['input']
  partnerCreated?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientsArgs = {
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryCoverLetterExampleArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryCoverLettersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  coverLetterIds?: InputMaybe<Array<Scalars['ID']['input']>>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryEmailVerifyAllowedArgs = {
  emailVerificationCode: Scalars['String']['input']
}

export type QueryFakeJobArgs = {
  companyName: Scalars['String']['input']
  datePosted?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryFindUsersJobByInfoArgs = {
  companyName: Scalars['String']['input']
  location?: InputMaybe<Scalars['String']['input']>
  position: Scalars['String']['input']
  url?: InputMaybe<Scalars['String']['input']>
}

export type QueryFindUsersJobByUrlArgs = {
  url: Scalars['String']['input']
}

export type QueryGetAboutCompanyInfoArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetGlassdoorResultsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetLatestCompanyInfoArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetLinkedinConnectionsUrlArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetPossibleLinkedinCompanyArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryHasAddedJobListingArgs = {
  jobListingId: Scalars['ID']['input']
}

export type QueryHeadshotRequestsArgs = {
  headshotRequestIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryHiringManagersFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryInterviewsArgs = {
  interviewIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryJobListingArgs = {
  jobListingId: Scalars['ID']['input']
}

export type QueryLocationsTypeaheadArgs = {
  location: Scalars['String']['input']
}

export type QueryNetworkingPeopleFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryPaginatedJobListingsArgs = {
  attributes?: InputMaybe<JobListingsFilterInputObject>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobListingsSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}

export type QueryPaginatedResumeExamplesArgs = {
  category?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryPaginatedUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobPostingSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}

export type QueryPublicResumeArgs = {
  publicId: Scalars['ID']['input']
}

export type QueryResetPasswordAllowedArgs = {
  resetPasswordToken: Scalars['String']['input']
}

export type QueryResumeExampleArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryResumeScoreArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumeSimpleAnalysisArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumeUnauthenticatedArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumesArgs = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>
  aiGeneratedForJobTitle?: InputMaybe<Scalars['Boolean']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  resumeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryResumesPdfBlobArgs = {
  resumeId?: InputMaybe<Scalars['ID']['input']>
}

export type QuerySameEducationProfilesFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QuerySimilarCareerPathsArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarCoverLetterExamplesArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarInterviewQuestionsArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarProfilesFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QuerySimilarResumeExamplesArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  partnerCreated?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryUsersJobsDateRangeArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum ResumeDocumentType {
  Doc = 'DOC',
  Pdf = 'PDF',
}

export type ResumePreferencesInputObject = {
  dateFormat?: InputMaybe<ResumesDateFormatEnum>
  fontFamily?: InputMaybe<ResumesFontFamilyEnum>
  fontSize?: InputMaybe<ResumesFontSizeEnum>
  hideCertifications?: InputMaybe<Scalars['Boolean']['input']>
  hideCourseworks?: InputMaybe<Scalars['Boolean']['input']>
  hideEducations?: InputMaybe<Scalars['Boolean']['input']>
  hideInvolvements?: InputMaybe<Scalars['Boolean']['input']>
  hideProjects?: InputMaybe<Scalars['Boolean']['input']>
  hideSkills?: InputMaybe<Scalars['Boolean']['input']>
  hideSummary?: InputMaybe<Scalars['Boolean']['input']>
  hideTargetTitle?: InputMaybe<Scalars['Boolean']['input']>
  hideWorkExperiences?: InputMaybe<Scalars['Boolean']['input']>
  horizontalMargin?: InputMaybe<ResumesHorizontalMarginEnum>
  lineHeight?: InputMaybe<ResumesLineHeightEnum>
  pageSize?: InputMaybe<ResumesPageSizeEnum>
  sectionTitleCasing?: InputMaybe<ResumesSectionTitleCasingEnum>
  sectionsOrder?: InputMaybe<Array<ResumeSortableSections>>
  sectionsOrderWithCustomSections?: InputMaybe<Array<Scalars['String']['input']>>
  template?: InputMaybe<ResumesTemplateEnum>
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
  verticalMargin?: InputMaybe<ResumesVerticalMarginEnum>
}

export enum ResumeScoreSectionType {
  ContentLength = 'CONTENT_LENGTH',
  ContentQuality = 'CONTENT_QUALITY',
  FieldCompletion = 'FIELD_COMPLETION',
}

export enum ResumeSortableSections {
  Certifications = 'CERTIFICATIONS',
  Courseworks = 'COURSEWORKS',
  Educations = 'EDUCATIONS',
  Involvements = 'INVOLVEMENTS',
  Projects = 'PROJECTS',
  Skills = 'SKILLS',
  WorkExperiences = 'WORK_EXPERIENCES',
}

export type Resumes = {
  __typename?: 'Resumes'
  aiGenerated: Scalars['Boolean']['output']
  archived: Scalars['Boolean']['output']
  category?: Maybe<Scalars['String']['output']>
  certifications: Array<ResumesCertification>
  courseworks: Array<ResumesCoursework>
  createdAt: Scalars['ISO8601DateTime']['output']
  customSections: Array<ResumesCustomSection>
  documentType?: Maybe<ResumeDocumentType>
  documentUrl?: Maybe<Scalars['String']['output']>
  educations: Array<ResumesEducation>
  email?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  groupedSkills: Array<ResumesGroupedSkill>
  hideCertifications: Scalars['Boolean']['output']
  hideCourseworks: Scalars['Boolean']['output']
  hideEducations: Scalars['Boolean']['output']
  hideInvolvements: Scalars['Boolean']['output']
  hideProjects: Scalars['Boolean']['output']
  hideSkills: Scalars['Boolean']['output']
  hideSummary: Scalars['Boolean']['output']
  hideTargetTitle: Scalars['Boolean']['output']
  hideWorkExperiences: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  interviewRate?: Maybe<Scalars['Int']['output']>
  involvements: Array<ResumesInvolvement>
  isPublic: Scalars['Boolean']['output']
  lastAnalyzedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  linkedinUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  mostRecentEmployer?: Maybe<Scalars['String']['output']>
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  nameSlug?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  preferences: ResumesPreferences
  professionalSummary?: Maybe<Scalars['String']['output']>
  projects: Array<ResumesProject>
  publicId: Scalars['ID']['output']
  sectionsOrder: Array<ResumeSortableSections>
  showOriginalDocument: Scalars['Boolean']['output']
  simpleAnalysis: Array<FieldMessageType>
  suggestedSkills: Array<Scalars['String']['output']>
  targetTitle?: Maybe<Scalars['String']['output']>
  template: ResumesTemplateEnum
  templateColorEnum?: Maybe<ResumesTemplateColorEnum>
  tokenResumeAnalysis: Scalars['Int']['output']
  uniqueId?: Maybe<Scalars['ID']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  website?: Maybe<Scalars['String']['output']>
  workExperiences: Array<ResumesWorkExperience>
}

export type ResumesAnalysisSkillType = {
  __typename?: 'ResumesAnalysisSkillType'
  category?: Maybe<Scalars['String']['output']>
  skill: Scalars['String']['output']
}

export type ResumesAnalysisSkillTypeInputObject = {
  category: Scalars['String']['input']
  skill: Scalars['String']['input']
}

export type ResumesAvatarPreferences = {
  __typename?: 'ResumesAvatarPreferences'
  profilePictureEnabled: Scalars['Boolean']['output']
  profilePictureShape?: Maybe<ResumesProfilePictureShapeEnum>
}

export type ResumesCertification = {
  __typename?: 'ResumesCertification'
  completionDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  provider?: Maybe<Scalars['String']['output']>
  showYearOnlyCompletionDate: Scalars['Boolean']['output']
}

export type ResumesCertificationInputObject = {
  completionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  provider?: InputMaybe<Scalars['String']['input']>
  showYearOnlyCompletionDate?: InputMaybe<Scalars['Boolean']['input']>
}

export type ResumesCoursework = {
  __typename?: 'ResumesCoursework'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnCourse: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
}

export type ResumesCourseworkInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnCourse?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  institutionName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
}

export type ResumesCustomSection = {
  __typename?: 'ResumesCustomSection'
  customSectionExperiences: Array<ResumesCustomSectionExperience>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ResumesCustomSectionExperience = {
  __typename?: 'ResumesCustomSectionExperience'
  achievements: Scalars['String']['output']
  companyName?: Maybe<Scalars['String']['output']>
  currentlyInExperience: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  location?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesCustomSectionExperienceInputObject = {
  achievements: Scalars['String']['input']
  companyName?: InputMaybe<Scalars['String']['input']>
  currentlyInExperience?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesCustomSectionInputObject = {
  customSectionExperiencesAttributes: Array<ResumesCustomSectionExperienceInputObject>
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
}

export enum ResumesDateFormatEnum {
  LongName = 'LONG_NAME',
  Numbers = 'NUMBERS',
  ShortName = 'SHORT_NAME',
}

export type ResumesEducation = {
  __typename?: 'ResumesEducation'
  achievements: Array<Scalars['String']['output']>
  additionalInformation?: Maybe<Scalars['String']['output']>
  currentlyInEducation: Scalars['Boolean']['output']
  degree?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  gpa?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  institutionName: Scalars['String']['output']
  location?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesEducationInputObject = {
  achievements?: InputMaybe<Array<Scalars['String']['input']>>
  additionalInformation?: InputMaybe<Scalars['String']['input']>
  currentlyInEducation?: InputMaybe<Scalars['Boolean']['input']>
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  gpa?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  institutionName: Scalars['String']['input']
  location?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum ResumesFontFamilyEnum {
  Crimson = 'CRIMSON',
  Garamond = 'GARAMOND',
  Helvetica = 'HELVETICA',
  OpenSans = 'OPEN_SANS',
}

export enum ResumesFontSizeEnum {
  Small = 'SMALL',
  Standard = 'STANDARD',
}

export type ResumesGroupedSkill = {
  __typename?: 'ResumesGroupedSkill'
  category?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  skills: Array<Scalars['String']['output']>
}

export type ResumesGroupedSkillInputObject = {
  category?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  skills: Array<Scalars['String']['input']>
}

export enum ResumesHorizontalMarginEnum {
  Compact = 'COMPACT',
  Standard = 'STANDARD',
}

export type ResumesInputObject = {
  certificationsAttributes: Array<ResumesCertificationInputObject>
  courseworksAttributes: Array<ResumesCourseworkInputObject>
  customSectionsAttributes?: InputMaybe<Array<ResumesCustomSectionInputObject>>
  educationsAttributes: Array<ResumesEducationInputObject>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  groupedSkillsAttributes: Array<ResumesGroupedSkillInputObject>
  hideCertifications?: InputMaybe<Scalars['Boolean']['input']>
  hideCourseworks?: InputMaybe<Scalars['Boolean']['input']>
  hideEducations?: InputMaybe<Scalars['Boolean']['input']>
  hideInvolvements?: InputMaybe<Scalars['Boolean']['input']>
  hideProjects?: InputMaybe<Scalars['Boolean']['input']>
  hideSkills?: InputMaybe<Scalars['Boolean']['input']>
  hideSummary?: InputMaybe<Scalars['Boolean']['input']>
  hideTargetTitle?: InputMaybe<Scalars['Boolean']['input']>
  hideWorkExperiences?: InputMaybe<Scalars['Boolean']['input']>
  involvementsAttributes: Array<ResumesInvolvementInputObject>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedinUrl?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  professionalSummary?: InputMaybe<Scalars['String']['input']>
  profilePictureEnabled?: InputMaybe<Scalars['Boolean']['input']>
  profilePictureShape?: InputMaybe<ResumesProfilePictureShapeEnum>
  projectsAttributes: Array<ResumesProjectInputObject>
  sectionsOrder?: InputMaybe<Array<ResumeSortableSections>>
  targetTitle?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workExperiencesAttributes: Array<ResumesWorkExperienceInputObject>
}

export type ResumesInvolvement = {
  __typename?: 'ResumesInvolvement'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnInvolvement: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesInvolvementInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnInvolvement?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesIrrelevantAchievementType = {
  __typename?: 'ResumesIrrelevantAchievementType'
  achievementIndex: Scalars['Int']['output']
  achievementType: ResumesResumeAchievementTypeEnum
  achievementTypeId: Scalars['Int']['output']
  companyName?: Maybe<Scalars['String']['output']>
  irrelevantAchievementForJobTitle: Scalars['String']['output']
  position?: Maybe<Scalars['String']['output']>
  relevantAchievementForJobTitle: Scalars['String']['output']
}

export enum ResumesLineHeightEnum {
  Compact = 'COMPACT',
  Relaxed = 'RELAXED',
  Standard = 'STANDARD',
}

export enum ResumesPageSizeEnum {
  A4 = 'A4',
  Letter = 'LETTER',
}

export type ResumesPreferences = {
  __typename?: 'ResumesPreferences'
  avatar: ResumesAvatarPreferences
  dateFormat: ResumesDateFormatEnum
  fontFamily: ResumesFontFamilyEnum
  fontSize: ResumesFontSizeEnum
  hideCertifications: Scalars['Boolean']['output']
  hideCourseworks: Scalars['Boolean']['output']
  hideEducations: Scalars['Boolean']['output']
  hideInvolvements: Scalars['Boolean']['output']
  hideProjects: Scalars['Boolean']['output']
  hideSkills: Scalars['Boolean']['output']
  hideSummary: Scalars['Boolean']['output']
  hideTargetTitle: Scalars['Boolean']['output']
  hideWorkExperiences: Scalars['Boolean']['output']
  horizontalMargin: ResumesHorizontalMarginEnum
  lineHeight: ResumesLineHeightEnum
  pageSize: ResumesPageSizeEnum
  sectionTitleCasing: ResumesSectionTitleCasingEnum
  sectionsOrder: Array<ResumeSortableSections>
  sectionsOrderWithCustomSections: Array<Scalars['String']['output']>
  template: ResumesTemplateEnum
  templateColorEnum?: Maybe<ResumesTemplateColorEnum>
  verticalMargin: ResumesVerticalMarginEnum
}

export enum ResumesProfilePictureShapeEnum {
  Round = 'ROUND',
  Square = 'SQUARE',
}

export type ResumesProject = {
  __typename?: 'ResumesProject'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnProject: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  linkUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesProjectInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnProject?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesRelevantAchievementInputObject = {
  achievementIndex: Scalars['Int']['input']
  achievementType: ResumesResumeAchievementTypeEnum
  achievementTypeId: Scalars['ID']['input']
  relevantAchievementForJobTitle: Scalars['String']['input']
}

export enum ResumesResumeAchievementTypeEnum {
  WorkPosition = 'WORK_POSITION',
}

export type ResumesResumeRelevanceAnalysis = {
  __typename?: 'ResumesResumeRelevanceAnalysis'
  irrelevantAchievementsForJobTitle: Array<ResumesIrrelevantAchievementType>
  irrelevantSkillsForJobTitle: Array<ResumesAnalysisSkillType>
  isSummaryRelevantForJobTitle: Scalars['Boolean']['output']
  originalSummary?: Maybe<Scalars['String']['output']>
  relevantSummaryForJobTitle?: Maybe<Scalars['String']['output']>
  suggestedSkillsForJobTitle: Array<Scalars['String']['output']>
}

export type ResumesScoreFieldTagType = {
  __typename?: 'ResumesScoreFieldTagType'
  tagLink: Scalars['String']['output']
  tagName: Scalars['String']['output']
}

export type ResumesScoreFieldType = {
  __typename?: 'ResumesScoreFieldType'
  didPass: Scalars['Boolean']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  sectionType: ResumeScoreSectionType
  tags?: Maybe<Array<ResumesScoreFieldTagType>>
}

export type ResumesScoreType = {
  __typename?: 'ResumesScoreType'
  failed: Scalars['Int']['output']
  passed: Scalars['Int']['output']
  score: Scalars['Int']['output']
  scoreFields: Array<ResumesScoreFieldType>
  total: Scalars['Int']['output']
}

export enum ResumesSectionTitleCasingEnum {
  Capitalized = 'CAPITALIZED',
  Uppercase = 'UPPERCASE',
}

export enum ResumesTemplateColorEnum {
  BauhausLight = 'BAUHAUS_LIGHT',
  HarvardLight = 'HARVARD_LIGHT',
  NeueCyan = 'NEUE_CYAN',
  NeueEmerald = 'NEUE_EMERALD',
  NeueIndigo = 'NEUE_INDIGO',
  NeueLight = 'NEUE_LIGHT',
  OxfordCyan = 'OXFORD_CYAN',
  OxfordEmerald = 'OXFORD_EMERALD',
  OxfordIndigo = 'OXFORD_INDIGO',
  OxfordLight = 'OXFORD_LIGHT',
}

export enum ResumesTemplateEnum {
  Bauhaus = 'BAUHAUS',
  Harvard = 'HARVARD',
  Neue = 'NEUE',
  Oxford = 'OXFORD',
}

export enum ResumesVerticalMarginEnum {
  Compact = 'COMPACT',
  Standard = 'STANDARD',
}

export type ResumesWorkExperience = {
  __typename?: 'ResumesWorkExperience'
  companyDescription?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  id: Scalars['ID']['output']
  simpleAnalysis: Array<FieldMessageType>
  workPositions: Array<ResumesWorkPosition>
}

export type ResumesWorkExperienceInputObject = {
  companyDescription?: InputMaybe<Scalars['String']['input']>
  companyName: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  workPositionsAttributes: Array<ResumesWorkPositionInputObject>
}

export type ResumesWorkPosition = {
  __typename?: 'ResumesWorkPosition'
  achievements: Array<Scalars['String']['output']>
  currentlyInPosition: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  location?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  simpleAnalysis: Array<FieldMessageType>
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesWorkPositionInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyInPosition?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** Autogenerated return type of Roast. */
export type RoastPayload = {
  __typename?: 'RoastPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
}

export enum RoastRoleTypeEnum {
  Boss = 'BOSS',
  Colleague = 'COLLEAGUE',
  Comedian = 'COMEDIAN',
  Family = 'FAMILY',
  Friendly = 'FRIENDLY',
  Interviewer = 'INTERVIEWER',
  Mentor = 'MENTOR',
  Recruiter = 'RECRUITER',
  Spouse = 'SPOUSE',
}

export enum RoastToneLevelEnum {
  Dark = 'DARK',
  Direct = 'DIRECT',
  Friendly = 'FRIENDLY',
  Humorous = 'HUMOROUS',
  Informative = 'INFORMATIVE',
  Inspirational = 'INSPIRATIONAL',
}

/** Autogenerated return type of SampleInterviewQuestions. */
export type SampleInterviewQuestionsPayload = {
  __typename?: 'SampleInterviewQuestionsPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
  usersJobId: Scalars['ID']['output']
}

export type SimilarProfiles = {
  __typename?: 'SimilarProfiles'
  education: Array<SimilarProfilesEducation>
  emails?: Maybe<Array<Scalars['String']['output']>>
  experience: Array<SimilarProfilesExperience>
  fullName: Scalars['String']['output']
  linkedinProfilePictureUrl?: Maybe<Scalars['String']['output']>
  linkedinUrl: Scalars['String']['output']
  occupation?: Maybe<Scalars['String']['output']>
}

export type SimilarProfilesEducation = {
  __typename?: 'SimilarProfilesEducation'
  degreeName?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  fieldOfStudy?: Maybe<Scalars['String']['output']>
  school: Scalars['String']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type SimilarProfilesEducationInputObject = {
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>
  school: Scalars['String']['input']
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type SimilarProfilesExperience = {
  __typename?: 'SimilarProfilesExperience'
  company: Scalars['String']['output']
  companyLinkedinProfileUrl?: Maybe<Scalars['String']['output']>
  companyLogoUrl?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  location?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  title: Scalars['String']['output']
}

export type SimilarProfilesExperienceInputObject = {
  company: Scalars['String']['input']
  companyLinkedinProfileUrl?: InputMaybe<Scalars['String']['input']>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export type SimilarProfilesInputObject = {
  education: Array<SimilarProfilesEducationInputObject>
  experience: Array<SimilarProfilesExperienceInputObject>
  fullName: Scalars['String']['input']
  linkedinProfilePictureUrl?: InputMaybe<Scalars['String']['input']>
  linkedinUrl: Scalars['String']['input']
  occupation: Scalars['String']['input']
}

export enum SimilarProfilesMatchTypeEnum {
  Company = 'COMPANY',
  Education = 'EDUCATION',
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER',
  SimilarRole = 'SIMILAR_ROLE',
}

export type SimilarProfilesMessage = {
  __typename?: 'SimilarProfilesMessage'
  body: Scalars['String']['output']
  subject: Scalars['String']['output']
}

export enum SortByDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** The subscription root for the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription'
  formFieldsMapping: FormFieldsMappingPayload
  glassdoor: GlassdoorResultsPayload
  learnSkills: LearnSkillsPayload
  ocrResume: OcrResumePayload
  roast: RoastPayload
  sampleInterviewQuestions: SampleInterviewQuestionsPayload
}

export enum SubscriptionPlanEnum {
  Free = 'FREE',
  Gold = 'GOLD',
  GoldQuarterly = 'GOLD_QUARTERLY',
  Pro = 'PRO',
  ProQuarterly = 'PRO_QUARTERLY',
}

export type Users = {
  __typename?: 'Users'
  activeResumes?: Maybe<Array<Resumes>>
  activeResumesCount: Scalars['Int']['output']
  advisor?: Maybe<Users>
  advisoryOrganization?: Maybe<AdvisoryOrganization>
  certifications: Array<ResumesCertification>
  completedAllChecklistItems: Scalars['Boolean']['output']
  courseworks: Array<ResumesCoursework>
  coverLetterCustomPrompt?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  educations: Array<ResumesEducation>
  email: Scalars['String']['output']
  enableJobNotifications: Scalars['Boolean']['output']
  enableJobRecommendationsNotifications: Scalars['Boolean']['output']
  firstName?: Maybe<Scalars['String']['output']>
  groupedSkills: Array<ResumesGroupedSkill>
  hasCompletedOnboarding: Scalars['Boolean']['output']
  hasCompletedResumeTour: Scalars['Boolean']['output']
  hasSeenGoldOnboarding: Scalars['Boolean']['output']
  hasSubscription: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  involvements: Array<ResumesInvolvement>
  isAdvisoryClient: Scalars['Boolean']['output']
  isAdvisoryOrgAccount: Scalars['Boolean']['output']
  jobExperienceLevel?: Maybe<JobListingExperienceLevelEnum>
  jobListingSavedSearches: Array<JobListingSavedSearch>
  jobsAddedThisWeek: Scalars['Int']['output']
  jobsToFollowUp: Array<UsersJobs>
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastJobUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  latestCity?: Maybe<Scalars['String']['output']>
  latestState?: Maybe<Scalars['String']['output']>
  linkedinUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  numClients: Scalars['Int']['output']
  numJobs: Scalars['Int']['output']
  numOwnClients: Scalars['Int']['output']
  numStartedInterviews: Scalars['Int']['output']
  numUploadedResumes: Scalars['Int']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  plan: SubscriptionPlanEnum
  profilePictureUrl?: Maybe<Scalars['String']['output']>
  projects: Array<ResumesProject>
  referralTokens: Scalars['Int']['output']
  resumeJobAchievementCustomPrompt?: Maybe<Scalars['String']['output']>
  resumeSummaryCustomPrompt?: Maybe<Scalars['String']['output']>
  role: UsersRoleEnum
  targetJobTitle?: Maybe<Scalars['String']['output']>
  thankYouJobs: Array<UsersJobs>
  tokenAchievements: Scalars['Int']['output']
  tokenCoverLetter: Scalars['Int']['output']
  tokenDownloadPdfs: Scalars['Int']['output']
  tokenInterview: Scalars['Int']['output']
  tokenInterviewQuestions: Scalars['Int']['output']
  tokenJobMatch: Scalars['Int']['output']
  tokenLearnSkills: Scalars['Int']['output']
  tokenOptimizeResume: Scalars['Int']['output']
  tokenProfessionalSummary: Scalars['Int']['output']
  tokenSalaryInsights: Scalars['Int']['output']
  tokenWriter: Scalars['Int']['output']
  uniqueId: Scalars['String']['output']
  usedChromeExtension: Scalars['Boolean']['output']
  usedJobAiFeature: Scalars['Boolean']['output']
  usedResumeAiFeature: Scalars['Boolean']['output']
  usersJobs: Array<UsersJobs>
  verified: Scalars['Boolean']['output']
  website?: Maybe<Scalars['String']['output']>
  workExperiences: Array<ResumesWorkExperience>
  writingStyleEnum?: Maybe<UsersWritingStyleEnum>
}

export type UsersInputObject = {
  certificationsAttributes?: InputMaybe<Array<ResumesCertificationInputObject>>
  courseworksAttributes?: InputMaybe<Array<ResumesCourseworkInputObject>>
  educationsAttributes?: InputMaybe<Array<ResumesEducationInputObject>>
  enableJobNotifications?: InputMaybe<Scalars['Boolean']['input']>
  enableJobRecommendationsNotifications?: InputMaybe<Scalars['Boolean']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  groupedSkillsAttributes?: InputMaybe<Array<ResumesGroupedSkillInputObject>>
  hasCompletedOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  hasCompletedResumeTour?: InputMaybe<Scalars['Boolean']['input']>
  hasSeenGoldOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  involvementsAttributes?: InputMaybe<Array<ResumesInvolvementInputObject>>
  jobExperienceLevel?: InputMaybe<JobListingExperienceLevelEnum>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedinUrl?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  projectsAttributes?: InputMaybe<Array<ResumesProjectInputObject>>
  targetJobTitle?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workExperiencesAttributes?: InputMaybe<Array<ResumesWorkExperienceInputObject>>
}

export type UsersJobActivity = {
  __typename?: 'UsersJobActivity'
  activityDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  activityType?: Maybe<UsersJobsActivityTypeEnum>
  id: Scalars['ID']['output']
  payload?: Maybe<Scalars['String']['output']>
}

export type UsersJobs = {
  __typename?: 'UsersJobs'
  applicationInstructions?: Maybe<Scalars['String']['output']>
  appliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  appliedChecklist: Array<UsersJobsAppliedChecklistItem>
  archived: Scalars['Boolean']['output']
  checklist: Array<UsersJobsChecklistItem>
  clientsShared: Array<Users>
  companyDomain?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  contacts?: Maybe<Array<Contacts>>
  coverLetter?: Maybe<UsersJobsCoverLetterType>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  interviewChecklist: Array<UsersJobsInterviewChecklistItem>
  interviewStep?: Maybe<UsersJobsInterviewStepEnum>
  interviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  isRemote?: Maybe<Scalars['Boolean']['output']>
  jobDetails?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  matchLevel?: Maybe<UsersJobsMatchEnum>
  notes?: Maybe<Scalars['String']['output']>
  numClientsApplied: Scalars['Int']['output']
  numClientsShared: Scalars['Int']['output']
  offerAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  partnerArchived: Scalars['Boolean']['output']
  partnerCreatedByUser?: Maybe<Users>
  payPeriod: UsersJobsPayPeriodEnum
  position: Scalars['String']['output']
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedStage?: Maybe<UsersJobsRejectedStageEnum>
  resume?: Maybe<Resumes>
  salaryMax?: Maybe<Scalars['Int']['output']>
  salaryMin?: Maybe<Scalars['Int']['output']>
  status: UsersJobsStatusEnum
  updatedAt: Scalars['ISO8601DateTime']['output']
  url?: Maybe<Scalars['String']['output']>
  usersJobActivities: Array<UsersJobActivity>
  wishlistChecklist: Array<UsersJobsWishlistChecklistItem>
}

export enum UsersJobsActivityTypeEnum {
  ResumeOptimized = 'RESUME_OPTIMIZED',
  StatusApplied = 'STATUS_APPLIED',
  StatusInterview = 'STATUS_INTERVIEW',
  StatusOffer = 'STATUS_OFFER',
  StatusRejected = 'STATUS_REJECTED',
  StatusWishlist = 'STATUS_WISHLIST',
  UsersJobCreated = 'USERS_JOB_CREATED',
}

export enum UsersJobsAppliedChecklistEnum {
  FollowUp_1Week = 'FOLLOW_UP_1_WEEK',
  FollowUp_2Weeks = 'FOLLOW_UP_2_WEEKS',
  FollowUp_3Weeks = 'FOLLOW_UP_3_WEEKS',
}

export type UsersJobsAppliedChecklistItem = {
  __typename?: 'UsersJobsAppliedChecklistItem'
  appliedChecklistEnum: UsersJobsAppliedChecklistEnum
  completed: Scalars['Boolean']['output']
}

export enum UsersJobsChecklistEnum {
  CheckMatchLevel = 'CHECK_MATCH_LEVEL',
  FollowUp_1Week = 'FOLLOW_UP_1_WEEK',
  FollowUp_2Weeks = 'FOLLOW_UP_2_WEEKS',
  FollowUp_3Weeks = 'FOLLOW_UP_3_WEEKS',
  MessagePeople = 'MESSAGE_PEOPLE',
  MockInterview = 'MOCK_INTERVIEW',
  ResearchCompanyInterview = 'RESEARCH_COMPANY_INTERVIEW',
  ResearchCompanyWishlist = 'RESEARCH_COMPANY_WISHLIST',
  ThankYouEmail = 'THANK_YOU_EMAIL',
}

export type UsersJobsChecklistItem = {
  __typename?: 'UsersJobsChecklistItem'
  checklistEnum: UsersJobsChecklistEnum
  completed: Scalars['Boolean']['output']
}

export type UsersJobsCoverLetterInputObject = {
  body?: InputMaybe<Scalars['String']['input']>
  candidateAddress?: InputMaybe<Scalars['String']['input']>
  companyLocation?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  footer?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

export type UsersJobsCoverLetterType = {
  __typename?: 'UsersJobsCoverLetterType'
  archived: Scalars['Boolean']['output']
  body?: Maybe<Scalars['String']['output']>
  candidateAddress?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  companyLocation?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  email?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  footer?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  mostRecentUsedResumeForGenerate?: Maybe<Resumes>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  usersJob: UsersJobs
}

export enum UsersJobsInterviewChecklistEnum {
  MockInterview = 'MOCK_INTERVIEW',
  ResearchCompanyInterview = 'RESEARCH_COMPANY_INTERVIEW',
  ThankYouEmail = 'THANK_YOU_EMAIL',
}

export type UsersJobsInterviewChecklistItem = {
  __typename?: 'UsersJobsInterviewChecklistItem'
  completed: Scalars['Boolean']['output']
  interviewChecklistEnum: UsersJobsInterviewChecklistEnum
}

export enum UsersJobsInterviewStepEnum {
  IntroScreen = 'INTRO_SCREEN',
  Onsite = 'ONSITE',
  PhoneScreen = 'PHONE_SCREEN',
}

export type UsersJobsMatch = {
  __typename?: 'UsersJobsMatch'
  hardSkills: Array<Scalars['String']['output']>
  matchLevel: UsersJobsMatchEnum
  matches: Array<FieldMessageType>
}

export enum UsersJobsMatchEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum UsersJobsPayPeriodEnum {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export type UsersJobsPerformanceDateRange = {
  __typename?: 'UsersJobsPerformanceDateRange'
  allJobs: Array<UsersJobs>
  appliedJobs: Array<UsersJobs>
  interviewedJobs: Array<UsersJobs>
  numAllJobs: Scalars['Int']['output']
  numAppliedJobs: Scalars['Int']['output']
  numInterviewedJobs: Scalars['Int']['output']
  numOfferedJobs: Scalars['Int']['output']
  numRejectedJobs: Scalars['Int']['output']
  offeredJobs: Array<UsersJobs>
  rejectedJobs: Array<UsersJobs>
}

export enum UsersJobsRejectedStageEnum {
  Application = 'APPLICATION',
  Interview = 'INTERVIEW',
  Reference = 'REFERENCE',
}

export enum UsersJobsStatusEnum {
  Applied = 'APPLIED',
  Interview = 'INTERVIEW',
  Offer = 'OFFER',
  Rejected = 'REJECTED',
  Wishlist = 'WISHLIST',
}

export enum UsersJobsWishlistChecklistEnum {
  CheckMatchLevel = 'CHECK_MATCH_LEVEL',
  MessagePeople = 'MESSAGE_PEOPLE',
  ResearchCompanyWishlist = 'RESEARCH_COMPANY_WISHLIST',
}

export type UsersJobsWishlistChecklistItem = {
  __typename?: 'UsersJobsWishlistChecklistItem'
  completed: Scalars['Boolean']['output']
  wishlistChecklistEnum: UsersJobsWishlistChecklistEnum
}

export enum UsersRoleEnum {
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  Advisor = 'ADVISOR',
  Jobseeker = 'JOBSEEKER',
}

export enum UsersWritingStyleEnum {
  BalancedProfessional = 'BALANCED_PROFESSIONAL',
  CreativeSpirit = 'CREATIVE_SPIRIT',
  StrategicProfessional = 'STRATEGIC_PROFESSIONAL',
  TechnicalAuthority = 'TECHNICAL_AUTHORITY',
}

export type WritingSample = {
  __typename?: 'WritingSample'
  answer: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  question: Scalars['String']['output']
}

export type AdvisorsList_AdvisorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<UsersRoleEnum>
  sortBy?: InputMaybe<AdvisorSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type AdvisorsList_AdvisorsQuery = {
  __typename?: 'Query'
  advisors: {
    __typename?: 'PaginatedAdvisorUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'AdvisorUsers'
      id: string
      jobsShared: Array<{
        __typename?: 'UsersJobs'
        id: string
        applicationInstructions?: string | null
        createdAt: any
        companyName: string
        isRemote?: boolean | null
        jobDetails?: string | null
        location?: string | null
        notes?: string | null
        payPeriod: UsersJobsPayPeriodEnum
        position: string
        salaryMax?: number | null
        salaryMin?: number | null
        status: UsersJobsStatusEnum
        updatedAt: any
        url?: string | null
        archived: boolean
        rejectedStage?: UsersJobsRejectedStageEnum | null
        interviewStep?: UsersJobsInterviewStepEnum | null
        numClientsApplied: number
        numClientsShared: number
        partnerArchived: boolean
        checklist: Array<{
          __typename?: 'UsersJobsChecklistItem'
          checklistEnum: UsersJobsChecklistEnum
          completed: boolean
        }>
        partnerCreatedByUser?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        contacts?: Array<{
          __typename?: 'Contacts'
          id: string
          email?: string | null
          name?: string | null
        }> | null
        resume?: { __typename?: 'Resumes'; id: string; name: string } | null
      }>
      jobsAdded: Array<{
        __typename?: 'UsersJobs'
        id: string
        applicationInstructions?: string | null
        createdAt: any
        companyName: string
        isRemote?: boolean | null
        jobDetails?: string | null
        location?: string | null
        notes?: string | null
        payPeriod: UsersJobsPayPeriodEnum
        position: string
        salaryMax?: number | null
        salaryMin?: number | null
        status: UsersJobsStatusEnum
        updatedAt: any
        url?: string | null
        archived: boolean
        rejectedStage?: UsersJobsRejectedStageEnum | null
        interviewStep?: UsersJobsInterviewStepEnum | null
        numClientsApplied: number
        numClientsShared: number
        partnerArchived: boolean
        checklist: Array<{
          __typename?: 'UsersJobsChecklistItem'
          checklistEnum: UsersJobsChecklistEnum
          completed: boolean
        }>
        partnerCreatedByUser?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        contacts?: Array<{
          __typename?: 'Contacts'
          id: string
          email?: string | null
          name?: string | null
        }> | null
        resume?: { __typename?: 'Resumes'; id: string; name: string } | null
      }>
      user: {
        __typename?: 'Users'
        id: string
        numOwnClients: number
        uniqueId: string
        role: UsersRoleEnum
        email: string
        firstName?: string | null
        lastName?: string | null
        plan: SubscriptionPlanEnum
        activeResumesCount: number
        coverLetterCustomPrompt?: string | null
        hasCompletedResumeTour: boolean
        resumeSummaryCustomPrompt?: string | null
        resumeJobAchievementCustomPrompt?: string | null
        tokenCoverLetter: number
        tokenDownloadPdfs: number
        tokenInterviewQuestions: number
        tokenJobMatch: number
        tokenProfessionalSummary: number
        tokenSalaryInsights: number
        tokenLearnSkills: number
        tokenAchievements: number
        tokenInterview: number
        tokenWriter: number
        tokenOptimizeResume: number
        usedChromeExtension: boolean
        numUploadedResumes: number
        numStartedInterviews: number
        referralTokens: number
        hasSubscription: boolean
        isAdvisoryClient: boolean
        isAdvisoryOrgAccount: boolean
        profilePictureUrl?: string | null
        writingStyleEnum?: UsersWritingStyleEnum | null
        hasSeenGoldOnboarding: boolean
        hasCompletedOnboarding: boolean
        jobExperienceLevel?: JobListingExperienceLevelEnum | null
        targetJobTitle?: string | null
        createdAt: any
        location?: string | null
      }
    }>
  }
}

export type ClientGroupClientContent_ClientGroupsQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type ClientGroupClientContent_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ClientGroupClientList_ClientGroupsQueryVariables = Exact<{
  clientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ClientGroupClientList_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{
    __typename?: 'ClientGroup'
    id: string
    name: string
    clients: Array<{
      __typename?: 'ClientUsers'
      id: string
      numAllJobs: number
      numInterviewedJobs: number
      numOfferedJobs: number
      numRejectedJobs: number
      numAppliedJobs: number
      user: {
        __typename?: 'Users'
        firstName?: string | null
        lastName?: string | null
        lastActiveAt?: any | null
        advisor?: {
          __typename?: 'Users'
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    }>
  }>
}

export type ClientBoard_ClientUsersJobsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  clientId: Scalars['ID']['input']
}>

export type ClientBoard_ClientUsersJobsQuery = {
  __typename?: 'Query'
  clientUsersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
}

export type ClientContent_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientContent_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    lastActiveAt?: any | null
    usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; archived: boolean }>
    activeResumes?: Array<{ __typename?: 'Resumes'; id: string }> | null
  }
}

export type ClientResumes_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientResumes_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    activeResumes?: Array<{
      __typename?: 'Resumes'
      id: string
      name: string
      createdAt: any
      updatedAt: any
    }> | null
  }
}

export type ClientsList_ClientsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ClientsList_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      numAllJobs: number
      numAppliedJobs: number
      numInterviewedJobs: number
      numOfferedJobs: number
      numRejectedJobs: number
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        lastActiveAt?: any | null
        advisor?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    }>
  }
}

export type JobPostingsList_JobPostingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<JobPostingSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type JobPostingsList_JobPostingsQuery = {
  __typename?: 'Query'
  paginatedUsersJobs: {
    __typename?: 'PaginatedUsersJobs'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'UsersJobs'
      id: string
      archived: boolean
      companyName: string
      createdAt: any
      numClientsApplied: number
      numClientsShared: number
      position: string
      location?: string | null
      isRemote?: boolean | null
      url?: string | null
      payPeriod: UsersJobsPayPeriodEnum
      salaryMin?: number | null
      salaryMax?: number | null
      clientsShared: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }>
    }>
  }
}

export type JobPostingsList_UpdateUsersJobArchivedMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type JobPostingsList_UpdateUsersJobArchivedMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; archived: boolean }
}

export type ApplicationChartContent_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  companyName: string
  appliedAt?: any | null
  createdAt: any
  interviewedAt?: any | null
}

export type ApplicationChartContent_UsersJobsDateRangeQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type ApplicationChartContent_UsersJobsDateRangeQuery = {
  __typename?: 'Query'
  usersJobsDateRange: {
    __typename?: 'UsersJobsPerformanceDateRange'
    numAllJobs: number
    numAppliedJobs: number
    numInterviewedJobs: number
    numOfferedJobs: number
    numRejectedJobs: number
    allJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
    appliedJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
    interviewedJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
  }
}

export type UserJobsActivityFragment = {
  __typename?: 'UsersJobs'
  id: string
  interviewStep?: UsersJobsInterviewStepEnum | null
  interviewedAt?: any | null
  createdAt: any
  appliedAt?: any | null
  offerAt?: any | null
  rejectedAt?: any | null
  rejectedStage?: UsersJobsRejectedStageEnum | null
}

export type ActivityTab_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ActivityTab_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    usersJobActivities: Array<{
      __typename?: 'UsersJobActivity'
      id: string
      activityType?: UsersJobsActivityTypeEnum | null
      activityDate?: any | null
      payload?: string | null
    }>
  }>
}

export type ApplicationDetailsPanel_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  companyName: string
  companyDomain?: string | null
}

export type ApplicationDetailsPanel_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationDetailsPanel_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }>
}

export type ApplicationDetailsPanel_GenerateCompanyDomainMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ApplicationDetailsPanel_GenerateCompanyDomainMutation = {
  __typename?: 'Mutation'
  generateCompanyDomain: {
    __typename?: 'UsersJobs'
    companyName: string
    companyDomain?: string | null
  }
}

export type ApplicationNotes_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationNotes_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; notes?: string | null }>
}

export type ApplicationNotes_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes: Scalars['String']['input']
}>

export type ApplicationNotes_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; notes?: string | null }
}

export type ApplicationsOverview_UsersJobsQueryVariables = Exact<{
  applicationId: Scalars['ID']['input']
}>

export type ApplicationsOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    position: string
    companyName: string
    status: UsersJobsStatusEnum
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }>
}

export type ApplicationsOverview_GenerateMessageForContactMutationVariables = Exact<{
  messageType: MessagesMessageType
  contactRelationship: MessagesContactType
  contactName: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  companyName: Scalars['String']['input']
}>

export type ApplicationsOverview_GenerateMessageForContactMutation = {
  __typename?: 'Mutation'
  generateMessageForContact: {
    __typename?: 'SimilarProfilesMessage'
    body: string
    subject: string
  }
}

export type CompanyActionBar_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyActionBar_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
    position: string
    createdAt: any
    updatedAt: any
    archived: boolean
    status: UsersJobsStatusEnum
    matchLevel?: UsersJobsMatchEnum | null
  }>
}

export type CompanyContactsOverview_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyContactsOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; companyName: string }>
}

export type CompanyContactsOverview_GetLinkedinConnectionsUrlQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyContactsOverview_GetLinkedinConnectionsUrlQuery = {
  __typename?: 'Query'
  getLinkedinConnectionsUrl: string
}

export type CompanyContactsOverview_NetworkingPeopleFromUsersJobQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyContactsOverview_NetworkingPeopleFromUsersJobQuery = {
  __typename?: 'Query'
  networkingPeopleFromUsersJob: Array<{
    __typename?: 'ProfileMatchSimilarProfile'
    matchTypes: Array<SimilarProfilesMatchTypeEnum>
    profile: {
      __typename?: 'SimilarProfiles'
      fullName: string
      linkedinProfilePictureUrl?: string | null
      linkedinUrl: string
      occupation?: string | null
      emails?: Array<string> | null
      education: Array<{
        __typename?: 'SimilarProfilesEducation'
        school: string
        degreeName?: string | null
        fieldOfStudy?: string | null
        startDate?: any | null
        endDate?: any | null
      }>
      experience: Array<{
        __typename?: 'SimilarProfilesExperience'
        company: string
        companyLinkedinProfileUrl?: string | null
        companyLogoUrl?: string | null
        endDate?: any | null
        startDate?: any | null
        location?: string | null
        title: string
      }>
    }
  }>
}

export type CompanyDetails_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  companyName: string
  companyDomain?: string | null
}

export type CompanyDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }>
}

export type CompanyDetails_GenerateCompanyDomainMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyDetails_GenerateCompanyDomainMutation = {
  __typename?: 'Mutation'
  generateCompanyDomain: {
    __typename?: 'UsersJobs'
    companyName: string
    companyDomain?: string | null
  }
}

export type CompanyDetails_UpdateUsersJobMutationVariables = Exact<{
  companyName?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}>

export type CompanyDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }
}

export type CompanyInsightsOverview_GetLatestCompanyInfoQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyInsightsOverview_GetLatestCompanyInfoQuery = {
  __typename?: 'Query'
  getLatestCompanyInfo?: {
    __typename?: 'CompanyLatestInfo'
    companyCultureAndPractices?: string | null
    missionAndVisionOfCompany?: string | null
    maximumSalary?: number | null
    minimumSalary?: number | null
    expectedSalaryMessage?: string | null
    accomplishmentsAndAnnouncementsAndProductReleases?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
    competitors?: Array<{
      __typename?: 'CompanyLatestInfoCompetitors'
      name: string
      website: string
    }> | null
    fundingsRounds?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
    growthFinancialNumbers?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
  } | null
}

export type CompanyInsightsOverview_GetGlassdoorResultsQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyInsightsOverview_GetGlassdoorResultsQuery = {
  __typename?: 'Query'
  getGlassdoorResults: string
}

export type GlassdoorResultsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type GlassdoorResultsSubscriptionSubscription = {
  __typename?: 'Subscription'
  glassdoor: {
    __typename?: 'GlassdoorResultsPayload'
    url?: string | null
    rating?: number | null
    whatProsUsersAreSaying?: string | null
    whatConsUsersAreSaying?: string | null
    whatConsUsersAreSayingAboutPosition?: string | null
    whatProsUsersAreSayingAboutPosition?: string | null
    usersJobId: string
    initial: boolean
    requestId: string
  }
}

export type CompanyOverview_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; companyName: string }>
}

export type CompanyOverview_GetAboutCompanyInfoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyOverview_GetAboutCompanyInfoQuery = {
  __typename?: 'Query'
  getAboutCompanyInfo?: {
    __typename?: 'CompanyAboutInfo'
    foundedYear?: number | null
    industry?: string | null
    linkedinCompanyUrl?: string | null
    location?: string | null
    numberOfEmployeeRangeMax?: number | null
    numberOfEmployeeRangeMin?: number | null
    websiteUrl?: string | null
    description?: string | null
  } | null
}

export type DocumentsTab_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type DocumentsTab_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
    coverLetter?: {
      __typename?: 'UsersJobsCoverLetterType'
      id: string
      name?: string | null
    } | null
  }>
}

export type InterviewingDetailsFragment = {
  __typename?: 'UsersJobs'
  status: UsersJobsStatusEnum
  interviewStep?: UsersJobsInterviewStepEnum | null
  rejectedStage?: UsersJobsRejectedStageEnum | null
  appliedAt?: any | null
  interviewedAt?: any | null
  resume?: { __typename?: 'Resumes'; id: string } | null
}

export type InterviewingDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type InterviewingDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    interviewStep?: UsersJobsInterviewStepEnum | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    appliedAt?: any | null
    interviewedAt?: any | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type InterviewingDetails_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  appliedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  status?: InputMaybe<UsersJobsStatusEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type InterviewingDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    interviewStep?: UsersJobsInterviewStepEnum | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    appliedAt?: any | null
    interviewedAt?: any | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type LearnSkills_LearnSkillsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type LearnSkills_LearnSkillsMutation = {
  __typename?: 'Mutation'
  learnSkills: { __typename?: 'CachedStreamingType'; result: string; isSync: boolean }
}

export type LearnSkillsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type LearnSkillsSubscriptionSubscription = {
  __typename?: 'Subscription'
  learnSkills: {
    __typename?: 'LearnSkillsPayload'
    content: string
    usersJobId: string
    initial: boolean
    requestId: string
    i?: number | null
  }
}

export type MatchScore_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MatchScore_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    aiGenerated: boolean
    name: string
    groupedSkills: Array<{ __typename?: 'ResumesGroupedSkill'; skills: Array<string> }>
  }>
}

export type MatchScore_AmIaGoodFitMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  resumeId: Scalars['ID']['input']
  position: Scalars['String']['input']
  jobDescription?: InputMaybe<Scalars['String']['input']>
}>

export type MatchScore_AmIaGoodFitMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: {
    __typename?: 'AmIAGoodFit'
    overallSummary?: string | null
    overallMatch?: UsersJobsMatchEnum | null
    relevantEducation?: string | null
    relevantEducationMatch?: boolean | null
    relevantExperience?: string | null
    relevantExperienceMatch?: boolean | null
    relevantSkills?: string | null
    relevantSkillsMatch?: boolean | null
  } | null
}

export type NextStepsChecklist_GetChecklistQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type NextStepsChecklist_GetChecklistQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }>
}

export type NextStepsChecklist_UpdateChecklistMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  appliedChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
  interviewChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
  wishlistChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
}>

export type NextStepsChecklist_UpdateChecklistMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }
}

export type PositionDetailsFragment = {
  __typename?: 'UsersJobs'
  interviewStep?: UsersJobsInterviewStepEnum | null
  isRemote?: boolean | null
  jobDetails?: string | null
  location?: string | null
  notes?: string | null
  payPeriod: UsersJobsPayPeriodEnum
  rejectedStage?: UsersJobsRejectedStageEnum | null
  position: string
  salaryMax?: number | null
  salaryMin?: number | null
  status: UsersJobsStatusEnum
  url?: string | null
  resume?: { __typename?: 'Resumes'; id: string } | null
}

export type PositionDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type PositionDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    rejectedStage?: UsersJobsRejectedStageEnum | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    url?: string | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type PositionDetails_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
}>

export type PositionDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    rejectedStage?: UsersJobsRejectedStageEnum | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    url?: string | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type SalaryInsights_SalaryInsightsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type SalaryInsights_SalaryInsightsMutation = {
  __typename?: 'Mutation'
  salaryInsights: string
}

export type ApplicationContent_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationContent_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    interviewedAt?: any | null
    createdAt: any
    appliedAt?: any | null
    offerAt?: any | null
    rejectedAt?: any | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    applicationInstructions?: string | null
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
  user: {
    __typename?: 'Users'
    id: string
    tokenSalaryInsights: number
    tokenJobMatch: number
    tokenLearnSkills: number
    tokenAchievements: number
    plan: SubscriptionPlanEnum
  }
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type ApplicationContent_UpdateUsersJobMutationVariables = Exact<{
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position?: InputMaybe<Scalars['String']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type ApplicationContent_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    interviewedAt?: any | null
    createdAt: any
    appliedAt?: any | null
    offerAt?: any | null
    rejectedAt?: any | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    applicationInstructions?: string | null
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type Applications_UsersJobsQueryVariables = Exact<{
  archived: Scalars['Boolean']['input']
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type Applications_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
}

export type Applications_GetMatchLevelsQueryVariables = Exact<{
  archived: Scalars['Boolean']['input']
}>

export type Applications_GetMatchLevelsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    archived: boolean
    matchLevel?: UsersJobsMatchEnum | null
  }>
}

export type Applications_UpdateUsersJobStatusMutationVariables = Exact<{
  id: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}>

export type Applications_UpdateUsersJobStatusMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type Applications_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
}>

export type Applications_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type CoverLetterFragment = {
  __typename?: 'UsersJobsCoverLetterType'
  id: string
  updatedAt: any
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  candidateAddress?: string | null
  companyName?: string | null
  companyLocation?: string | null
  phoneNumber?: string | null
  body?: string | null
  footer?: string | null
  archived: boolean
  mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
}

export type CoverLetterContent_CoverLettersQueryVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
}>

export type CoverLetterContent_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    usersJob: {
      __typename?: 'UsersJobs'
      id: string
      applicationInstructions?: string | null
      createdAt: any
      companyName: string
      isRemote?: boolean | null
      jobDetails?: string | null
      location?: string | null
      notes?: string | null
      payPeriod: UsersJobsPayPeriodEnum
      position: string
      salaryMax?: number | null
      salaryMin?: number | null
      status: UsersJobsStatusEnum
      updatedAt: any
      url?: string | null
      archived: boolean
      rejectedStage?: UsersJobsRejectedStageEnum | null
      interviewStep?: UsersJobsInterviewStepEnum | null
      numClientsApplied: number
      numClientsShared: number
      partnerArchived: boolean
      checklist: Array<{
        __typename?: 'UsersJobsChecklistItem'
        checklistEnum: UsersJobsChecklistEnum
        completed: boolean
      }>
      partnerCreatedByUser?: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      } | null
      contacts?: Array<{
        __typename?: 'Contacts'
        id: string
        email?: string | null
        name?: string | null
      }> | null
      resume?: { __typename?: 'Resumes'; id: string; name: string } | null
    }
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type CoverLettercontent_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type CoverLettercontent_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type CoverLetterContent_GenerateCoverLetterMutationVariables = Exact<{
  coverLetterLength?: InputMaybe<CoverLetterLengthEnum>
  coverLetterTone?: InputMaybe<CoverLetterToneEnum>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}>

export type CoverLetterContent_GenerateCoverLetterMutation = {
  __typename?: 'Mutation'
  generateCoverLetter: { __typename?: 'UsersJobsCoverLetterType'; id: string; body?: string | null }
}

export type CoverLetterContent_CoverLetterUpsertMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  attributes: UsersJobsCoverLetterInputObject
}>

export type CoverLetterContent_CoverLetterUpsertMutation = {
  __typename?: 'Mutation'
  coverLetterUpsert: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type CoverLettersList_CoverLettersQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type CoverLettersList_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    body?: string | null
    createdAt: any
    usersJob: { __typename?: 'UsersJobs'; id: string; companyName: string; position: string }
  }>
}

export type ListEmpty_CreateResumeMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type ListEmpty_CreateResumeMutation = {
  __typename?: 'Mutation'
  createResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type HeadshotsList_AllHeadshotsQueryVariables = Exact<{ [key: string]: never }>

export type HeadshotsList_AllHeadshotsQuery = {
  __typename?: 'Query'
  headshotRequests: Array<{ __typename?: 'HeadshotRequest'; id: string; createdAt: any }>
}

export type Interview_GetInterviewQueryVariables = Exact<{
  interviewId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type Interview_GetInterviewQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
    messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
  }>
}

export type InterviewsSidebar_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type InterviewsSidebar_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
  }>
}

export type Interviews_InterviewFragment = {
  __typename?: 'Interview'
  id: string
  status: InterviewsStatusEnum
  interviewType: InterviewsTypeEnum
  score?: number | null
  jobTitle: string
  messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
}

export type Interviews_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type Interviews_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
  }>
}

export type Interviews_InterviewAddMessageMutationVariables = Exact<{
  interviewId: Scalars['String']['input']
  message: Scalars['String']['input']
}>

export type Interviews_InterviewAddMessageMutation = {
  __typename?: 'Mutation'
  interviewAddMessage: {
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
    messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
  }
}

export type JobSearchDetailsPage_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobSearchDetailsPage_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: {
    __typename?: 'JobListings'
    id: string
    aiCoreResponsibilities?: string | null
    aiWorkArrangement?: JobListingWorkArrangementEnum | null
    aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
    aiRequirementsSummary?: string | null
    benefits: Array<string>
    companyDescription?: string | null
    companyDomain?: string | null
    companyIndustry?: string | null
    companyNumEmployees?: number | null
    companySpecialties: Array<string>
    companyLinkedinUrl?: string | null
    companyLogoUrl?: string | null
    employmentType?: JobListingEmploymentTypeEnum | null
    jobDetails?: string | null
    keySkills: Array<string>
    visaSponsorship: boolean
    workingHours?: number | null
    experienceLevelString?: string | null
    hiringManagerEmail?: string | null
    hiringManagerName?: string | null
    position: string
    companyName: string
    url?: string | null
    datePosted: any
    isRemote?: boolean | null
    location?: string | null
    salaryMax?: number | null
    salaryMin?: number | null
    salaryCurrency?: string | null
    payPeriod?: JobListingPayPeriodEnum | null
  }
  hasAddedJobListing?: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum } | null
}

export type JobSearchResultsPage_PaginatedJobListingsQueryVariables = Exact<{
  attributes?: InputMaybe<JobListingsFilterInputObject>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobListingsSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type JobSearchResultsPage_PaginatedJobListingsQuery = {
  __typename?: 'Query'
  paginatedJobListings: {
    __typename?: 'PaginatedJobListings'
    data: Array<{
      __typename?: 'JobListings'
      id: string
      position: string
      companyName: string
      url?: string | null
      companyLogoUrl?: string | null
      companyIndustry?: string | null
      datePosted: any
      isRemote?: boolean | null
      location?: string | null
      salaryMax?: number | null
      salaryMin?: number | null
      salaryCurrency?: string | null
      employmentType?: JobListingEmploymentTypeEnum | null
      payPeriod?: JobListingPayPeriodEnum | null
    }>
    pagination: {
      __typename?: 'Pagination'
      page: number
      pageSize: number
      totalCount: number
      totalPages: number
    }
  }
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    url?: string | null
    status: UsersJobsStatusEnum
  }>
}

export type JobPage_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobPage_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: { __typename?: 'JobListings'; id: string; companyName: string; position: string }
}

export type ResumePage_GetResumeQueryVariables = Exact<{
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumePage_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumesList_ResumesFragment = {
  __typename?: 'Resumes'
  id: string
  name: string
  archived: boolean
  createdAt: any
  updatedAt: any
  aiGenerated: boolean
}

export type ResumesList_AllResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumesList_AllResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type ResumesList_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>
  aiGeneratedForJobTitle?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type ResumesList_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }>
}

export type ResumeList_UpdateArchivedResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type ResumeList_UpdateArchivedResumeMutation = {
  __typename?: 'Mutation'
  updateArchivedResume: {
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }
}

export type ResumeList_DuplicateResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeList_DuplicateResumeMutation = {
  __typename?: 'Mutation'
  duplicateResume: {
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }
}

export type RoastResume_RoastResumeMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
  roleType: RoastRoleTypeEnum
  toneLevel: RoastToneLevelEnum
  token: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
}>

export type RoastResume_RoastResumeMutation = { __typename?: 'Mutation'; roastResume: string }

export type RoastSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type RoastSubscriptionSubscription = {
  __typename?: 'Subscription'
  roast: {
    __typename?: 'RoastPayload'
    content: string
    initial: boolean
    requestId: string
    i?: number | null
  }
}

export type ForgotPassword_AuthPasswordResetRequestMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type ForgotPassword_AuthPasswordResetRequestMutation = {
  __typename?: 'Mutation'
  authPasswordResetRequest: string
}

export type ResetPassword_ResetPasswordAllowedQueryVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordAllowedQuery = {
  __typename?: 'Query'
  resetPasswordAllowed: boolean
}

export type ResetPassword_ResetPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
  newPassword: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordMutation = {
  __typename?: 'Mutation'
  authResetPassword: string
}

export type EmailVerify_EmailVerifyAllowedQueryVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
}>

export type EmailVerify_EmailVerifyAllowedQuery = {
  __typename?: 'Query'
  emailVerifyAllowed?: {
    __typename?: 'Users'
    firstName?: string | null
    lastName?: string | null
    email: string
  } | null
}

export type ExperienceLevelPage_UpdateUserMutationVariables = Exact<{
  jobExperienceLevel: JobListingExperienceLevelEnum
}>

export type ExperienceLevelPage_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'Users'
    id: string
    jobExperienceLevel?: JobListingExperienceLevelEnum | null
  }
}

export type OnboardingFlow_CompleteOnboardingMutationVariables = Exact<{ [key: string]: never }>

export type OnboardingFlow_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; hasCompletedOnboarding: boolean }
}

export type ResumePage_GetResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumePage_GetResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type WelcomePage_UpdateUserMutationVariables = Exact<{
  jobTitle: Scalars['String']['input']
}>

export type WelcomePage_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; targetJobTitle?: string | null }
}

export type ApplicationSelect_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  companyName: string
  position: string
  jobDetails?: string | null
}

export type ApplicationSelect_UsersJobsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ApplicationSelect_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    position: string
    jobDetails?: string | null
  }>
}

export type Feedback_FeedbackCreateMutationVariables = Exact<{
  subject?: InputMaybe<Scalars['String']['input']>
  feedback: Scalars['String']['input']
}>

export type Feedback_FeedbackCreateMutation = { __typename?: 'Mutation'; createFeedback: string }

export type GoldOnboardingManager_CompleteOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type GoldOnboardingManager_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string }
}

export type Navigation_GetTodoTasksQueryVariables = Exact<{ [key: string]: never }>

export type Navigation_GetTodoTasksQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    usedChromeExtension: boolean
    usedJobAiFeature: boolean
    usedResumeAiFeature: boolean
    numJobs: number
    jobsAddedThisWeek: number
    jobsToFollowUp: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      appliedAt?: any | null
    }>
    thankYouJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      interviewedAt?: any | null
    }>
  }
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      }>
    }>
  }>
}

export type Navigation_ClientGroupsQueryVariables = Exact<{ [key: string]: never }>

export type Navigation_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ResumesSelect_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ResumesSelect_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type TodoTaskUsersFragment = {
  __typename?: 'Users'
  id: string
  usedChromeExtension: boolean
  usedJobAiFeature: boolean
  usedResumeAiFeature: boolean
  numJobs: number
  jobsAddedThisWeek: number
  jobsToFollowUp: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    appliedAt?: any | null
  }>
  thankYouJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    interviewedAt?: any | null
  }>
}

export type TodoTaskResumesFragment = {
  __typename?: 'Resumes'
  id: string
  simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
  workExperiences: Array<{
    __typename?: 'ResumesWorkExperience'
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workPositions: Array<{
      __typename?: 'ResumesWorkPosition'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    }>
  }>
}

export type TodoTasks_GetTodoTasksQueryVariables = Exact<{ [key: string]: never }>

export type TodoTasks_GetTodoTasksQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    usedChromeExtension: boolean
    usedJobAiFeature: boolean
    usedResumeAiFeature: boolean
    numJobs: number
    jobsAddedThisWeek: number
    jobsToFollowUp: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      appliedAt?: any | null
    }>
    thankYouJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      interviewedAt?: any | null
    }>
  }
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      }>
    }>
  }>
}

export type UpdateLastPageLoaded_UpdateLastPageLoadedAtMutationVariables = Exact<{
  [key: string]: never
}>

export type UpdateLastPageLoaded_UpdateLastPageLoadedAtMutation = {
  __typename?: 'Mutation'
  updateLastPageLoadedAt: { __typename?: 'Users'; id: string }
}

export type UsersUpdateFragment = {
  __typename?: 'Users'
  id: string
  firstName?: string | null
  lastName?: string | null
  phoneNumber?: string | null
  location?: string | null
  website?: string | null
  linkedinUrl?: string | null
  profilePictureUrl?: string | null
  enableJobNotifications: boolean
  enableJobRecommendationsNotifications: boolean
}

export type AccountSettingsDialog_UserQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_UserQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_UpdateUserMutationVariables = Exact<{
  attributes: UsersInputObject
}>

export type AccountSettingsDialog_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_UserUploadProfilePictureMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
}>

export type AccountSettingsDialog_UserUploadProfilePictureMutation = {
  __typename?: 'Mutation'
  userUploadProfilePicture: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_JobSearchPreferenceFragment = {
  __typename?: 'JobSearchPreference'
  positions?: Array<string> | null
  locations?: Array<string> | null
  keywords?: Array<string> | null
  employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
  experienceLevels?: Array<JobListingExperienceLevelEnum> | null
  workArrangements?: Array<JobListingWorkArrangementEnum> | null
  datePosted?: JobListingDatePostedEnum | null
  educationRequirement?: JobListingEducationLevelEnum | null
  salaryMin?: number | null
  payPeriod?: JobListingPayPeriodEnum | null
  companyNumEmployeesMin?: number | null
  companyNumEmployeesMax?: number | null
  visaSponsorship?: boolean | null
}

export type AccountSettingsDialog_JobSearchPreferenceQueryVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_JobSearchPreferenceQuery = {
  __typename?: 'Query'
  jobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type AccountSettingsDialog_UpsertJobSearchPreferenceMutationVariables = Exact<{
  attributes: JobSearchPreferenceInputObject
}>

export type AccountSettingsDialog_UpsertJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  userUpsertJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type CreateClientGroupDialog_ClientGroupFragment = {
  __typename?: 'ClientGroup'
  id: string
  clients: Array<{ __typename?: 'ClientUsers'; id: string }>
}

export type CreateClientGroupDialog_CreateClientGroupMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type CreateClientGroupDialog_CreateClientGroupMutation = {
  __typename?: 'Mutation'
  createClientGroup: {
    __typename?: 'ClientGroup'
    id: string
    clients: Array<{ __typename?: 'ClientUsers'; id: string }>
  }
}

export type CreateClientGroupDialog_AddUsersToClientGroupMutationVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type CreateClientGroupDialog_AddUsersToClientGroupMutation = {
  __typename?: 'Mutation'
  addUsersToClientGroup: {
    __typename?: 'ClientGroup'
    id: string
    clients: Array<{ __typename?: 'ClientUsers'; id: string }>
  }
}

export type CreateClientGroupDialog_ClientsQueryVariables = Exact<{ [key: string]: never }>

export type CreateClientGroupDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: { __typename?: 'Users'; firstName?: string | null; lastName?: string | null }
    }>
  }
}

export type DidYouApplyJobListingDialog_ApplyJobListingMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type DidYouApplyJobListingDialog_ApplyJobListingMutation = {
  __typename?: 'Mutation'
  markJobListingAsApplied: { __typename?: 'UsersJobs'; id: string }
}

export type EditClientGroupDialog_ClientGroupsQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type EditClientGroupDialog_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{
    __typename?: 'ClientGroup'
    id: string
    name: string
    clients: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }>
}

export type EditClientGroupDialog_ClientsQueryVariables = Exact<{ [key: string]: never }>

export type EditClientGroupDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; pageSize: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type EditClientGroupDialog_EditClientGroupMutationVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}>

export type EditClientGroupDialog_EditClientGroupMutation = {
  __typename?: 'Mutation'
  editClientGroup: { __typename?: 'ClientGroup'; id: string }
}

export type EnhanceAchievementDialog_GenerateOneJobAchievementMutationVariables = Exact<{
  workPositionId: Scalars['ID']['input']
  index: Scalars['Int']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type EnhanceAchievementDialog_GenerateOneJobAchievementMutation = {
  __typename?: 'Mutation'
  generateOneJobAchievement: string
}

export type EnhanceSummaryDialog_GenerateProfessionalSummaryMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  useExisting: Scalars['Boolean']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type EnhanceSummaryDialog_GenerateProfessionalSummaryMutation = {
  __typename?: 'Mutation'
  generateProfessionalSummary: string
}

export type FeedbackDialog_CreateFeedbackMutationVariables = Exact<{
  subject?: InputMaybe<Scalars['String']['input']>
  feedback: Scalars['String']['input']
}>

export type FeedbackDialog_CreateFeedbackMutation = {
  __typename?: 'Mutation'
  createFeedback: string
}

export type GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutationVariables =
  Exact<{
    resumeId: Scalars['ID']['input']
    similarProfile: SimilarProfilesInputObject
    usersJobId: Scalars['ID']['input']
    forHiringManager?: InputMaybe<Scalars['Boolean']['input']>
    forRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  }>

export type GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutation = {
  __typename?: 'Mutation'
  generateDraftEmailForSimilarProfile: {
    __typename?: 'SimilarProfilesMessage'
    body: string
    subject: string
  }
}

export type GoldOnboardingDialog_UserUpdateWritingStyleMutationVariables = Exact<{
  writingStyle: UsersWritingStyleEnum
}>

export type GoldOnboardingDialog_UserUpdateWritingStyleMutation = {
  __typename?: 'Mutation'
  userUpdateWritingStyle: { __typename?: 'Users'; id: string }
}

export type ImportResumeFromLinkedinDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type ImportResumeFromLinkedinDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutationVariables = Exact<{
  linkedinProfileUrl: Scalars['String']['input']
}>

export type ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutation = {
  __typename?: 'Mutation'
  createResumeFromLinkedinUrl: { __typename?: 'Resumes'; id: string }
}

export type InviteAdvisorDialog_InviteAdvisorMutationVariables = Exact<{
  email: Scalars['String']['input']
  role: UsersRoleEnum
}>

export type InviteAdvisorDialog_InviteAdvisorMutation = {
  __typename?: 'Mutation'
  inviteAdvisor?: { __typename?: 'Users'; id: string } | null
}

export type InviteClientDialog_InviteClientMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type InviteClientDialog_InviteClientMutation = {
  __typename?: 'Mutation'
  inviteClient?: { __typename?: 'Users'; id: string } | null
}

export type MatchLevelDialog_CheckFitMutationVariables = Exact<{
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
}>

export type MatchLevelDialog_CheckFitMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: {
    __typename?: 'AmIAGoodFit'
    overallSummary?: string | null
    overallMatch?: UsersJobsMatchEnum | null
    relevantEducation?: string | null
    relevantEducationMatch?: boolean | null
    relevantExperience?: string | null
    relevantExperienceMatch?: boolean | null
    relevantSkills?: string | null
    relevantSkillsMatch?: boolean | null
  } | null
}

export type NewApplicationDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewApplicationDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type NewApplicationDialog_CreateUsersJobMutationVariables = Exact<{
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  contact?: InputMaybe<ContactsInputObject>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position: Scalars['String']['input']
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  companyName: Scalars['String']['input']
  companyDomain?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewApplicationDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum }
}

export type NewApplicationsDialog_UsersJobsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewApplicationsDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    companyName: string
    url?: string | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    payPeriod: UsersJobsPayPeriodEnum
    applicationInstructions?: string | null
    companyDomain?: string | null
  }>
}

export type NewApplicationsDialog_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  position: Scalars['String']['input']
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  companyName: Scalars['String']['input']
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
}>

export type NewApplicationsDialog_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum }
}

export type NewCoverLetterDialog_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  archived: Scalars['Boolean']['input']
}>

export type NewCoverLetterDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    coverLetter?: { __typename?: 'UsersJobsCoverLetterType'; id: string } | null
  }>
}

export type NewCoverLetterDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewCoverLetterDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type NewCoverLetterDialog_CreateUsersJobMutationVariables = Exact<{
  position: Scalars['String']['input']
  status?: InputMaybe<UsersJobsStatusEnum>
  companyName: Scalars['String']['input']
  jobDetails?: InputMaybe<Scalars['String']['input']>
}>

export type NewCoverLetterDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type NewCoverLetterDialog_CoverLetterUpsertMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  attributes: UsersJobsCoverLetterInputObject
}>

export type NewCoverLetterDialog_CoverLetterUpsertMutation = {
  __typename?: 'Mutation'
  coverLetterUpsert: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type NewHeadshotDialog_CreateHeadshotRequestMutationVariables = Exact<{
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  uploadSignedId: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type NewHeadshotDialog_CreateHeadshotRequestMutation = {
  __typename?: 'Mutation'
  createHeadshotRequest: { __typename?: 'HeadshotRequest'; id: string }
}

export type NewInterviewDialog_ResumeQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewInterviewDialog_ResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type NewInterviewDialog_InterviewStartMockMutationVariables = Exact<{
  jobTitle: Scalars['String']['input']
  jobDescription?: InputMaybe<Scalars['String']['input']>
  interviewType: InterviewsTypeEnum
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewInterviewDialog_InterviewStartMockMutation = {
  __typename?: 'Mutation'
  interviewStartMock: { __typename?: 'Interview'; id: string }
}

export type NewResumeDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewResumeDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type NewResumeDialog_PaginatedResumeExamplesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
}>

export type NewResumeDialog_PaginatedResumeExamplesQuery = {
  __typename?: 'Query'
  paginatedResumeExamples: {
    __typename?: 'PaginatedResumeExamples'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'Resumes'
      id: string
      name: string
      nameSlug?: string | null
      category?: string | null
      exampleImageUrl?: string | null
    }>
  }
}

export type NewResumeDialog_ResumeExampleCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type NewResumeDialog_ResumeExampleCategoriesQuery = {
  __typename?: 'Query'
  resumeExampleCategories?: Array<string> | null
}

export type NewResumeDialog_ResumeExampleQueryVariables = Exact<{
  nameSlug: Scalars['String']['input']
}>

export type NewResumeDialog_ResumeExampleQuery = {
  __typename?: 'Query'
  resumeExample?: {
    __typename?: 'Resumes'
    id: string
    name: string
    nameSlug?: string | null
    category?: string | null
    exampleImageUrl?: string | null
  } | null
}

export type NewResumeDialog_CreateResumeFromLinkedinUrlMutationVariables = Exact<{
  linkedinProfileUrl: Scalars['String']['input']
}>

export type NewResumeDialog_CreateResumeFromLinkedinUrlMutation = {
  __typename?: 'Mutation'
  createResumeFromLinkedinUrl: { __typename?: 'Resumes'; id: string }
}

export type NewResumeDialog_DuplicateFromResumeExampleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewResumeDialog_DuplicateFromResumeExampleMutation = {
  __typename?: 'Mutation'
  duplicateResumeFromResumeExample: { __typename?: 'Resumes'; id: string }
}

export type RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String']['input']
}>

export type RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutation = {
  __typename?: 'Mutation'
  subscriptionsRedeemLtdPromoCode: { __typename?: 'Users'; id: string; plan: SubscriptionPlanEnum }
}

export type RequestResumeReviewDialog_RequestResumeReviewMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type RequestResumeReviewDialog_RequestResumeReviewMutation = {
  __typename?: 'Mutation'
  requestResumeReview: string
}

export type ShareJobPostingDialog_UsersJobsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ShareJobPostingDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    clientsShared: Array<{ __typename?: 'Users'; id: string }>
  }>
}

export type ShareJobPostingDialog_ClientsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type ShareJobPostingDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type ShareJobPostingDialog_ClientGroupsQueryVariables = Exact<{ [key: string]: never }>

export type ShareJobPostingDialog_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ShareJobPostingDialog_ShareJobWithClientsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  clientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ShareJobPostingDialog_ShareJobWithClientsMutation = {
  __typename?: 'Mutation'
  shareJobWithClients: { __typename?: 'UsersJobs'; id: string }
}

export type ShareResumeDialog_UpdatePublicResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isPublic: Scalars['Boolean']['input']
}>

export type ShareResumeDialog_UpdatePublicResumeMutation = {
  __typename?: 'Mutation'
  updatePublicResume: { __typename?: 'Resumes'; id: string; isPublic: boolean }
}

export type TailorResumeDialog_CreateUsersJobMutationVariables = Exact<{
  position: Scalars['String']['input']
  status?: InputMaybe<UsersJobsStatusEnum>
  companyName: Scalars['String']['input']
  jobDetails?: InputMaybe<Scalars['String']['input']>
}>

export type TailorResumeDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type TailorResumeDialog_OptimizeResumeForJobMutationVariables = Exact<{
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
}>

export type TailorResumeDialog_OptimizeResumeForJobMutation = {
  __typename?: 'Mutation'
  optimizeResumeForJobV2: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type TailorResumeDialog_FetchJobKeywordsMutationVariables = Exact<{
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
}>

export type TailorResumeDialog_FetchJobKeywordsMutation = {
  __typename?: 'Mutation'
  fetchJobKeywords: Array<string>
}

export type TailorResumeDialog_FetchMissingSkillsOfJobResumeMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  jobListingId: Scalars['ID']['input']
  resumeId: Scalars['ID']['input']
}>

export type TailorResumeDialog_FetchMissingSkillsOfJobResumeMutation = {
  __typename?: 'Mutation'
  fetchMissingSkillsOfJobResume: Array<string>
}

export type EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutationVariables = Exact<{
  achievementStrings: Array<Scalars['String']['input']> | Scalars['String']['input']
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutation = {
  __typename?: 'Mutation'
  generateJobAchievementFromString: Array<string>
}

export type ResumeTemplateDrawer_UpdateTemplateMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  template: ResumesTemplateEnum
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
}>

export type ResumeTemplateDrawer_UpdateTemplateMutation = {
  __typename?: 'Mutation'
  updateTemplateResume: {
    __typename?: 'Resumes'
    id: string
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
  }
}

export type AdvisorSheet_ClientsQueryVariables = Exact<{
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  page: Scalars['Int']['input']
  perPage: Scalars['Int']['input']
}>

export type AdvisorSheet_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type AdvisorSheet_AssignClientToAdvisorMutationVariables = Exact<{
  advisorId: Scalars['ID']['input']
  clientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type AdvisorSheet_AssignClientToAdvisorMutation = {
  __typename?: 'Mutation'
  assignClientToAdvisor: string
}

export type ApplicationToolbar_UsersJobsArchivedQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationToolbar_UsersJobsArchivedQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    archived: boolean
    position: string
    companyName: string
  }>
}

export type ApplicationToolbar_UpdateUsersJobArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archive?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ApplicationToolbar_UpdateUsersJobArchiveMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; archived: boolean }
}

export type BoardToolbar_UsersJobsQueryVariables = Exact<{ [key: string]: never }>

export type BoardToolbar_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string }>
}

export type ClientBoardToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientBoardToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientGroupToolbar_ClientGroupQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type ClientGroupToolbar_ClientGroupQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ClientResumeToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientResumeToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientsToolbar_AdvisorsQueryVariables = Exact<{ [key: string]: never }>

export type ClientsToolbar_AdvisorsQuery = {
  __typename?: 'Query'
  advisors: {
    __typename?: 'PaginatedAdvisorUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'AdvisorUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type CoverLetterToolbar_CoverLettersQueryVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
}>

export type CoverLetterToolbar_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    archived: boolean
    companyName?: string | null
    usersJob: { __typename?: 'UsersJobs'; position: string }
  }>
}

export type CoverLetterToolbar_UpdateArchivedCoverLetterMutationVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type CoverLetterToolbar_UpdateArchivedCoverLetterMutation = {
  __typename?: 'Mutation'
  updateArchivedCoverLetter: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    archived: boolean
  }
}

export type CoverLettersToolbar_CoverLettersQueryVariables = Exact<{ [key: string]: never }>

export type CoverLettersToolbar_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{ __typename?: 'UsersJobsCoverLetterType'; id: string }>
}

export type HeadshotsToolbar_HeadshotsQueryVariables = Exact<{ [key: string]: never }>

export type HeadshotsToolbar_HeadshotsQuery = {
  __typename?: 'Query'
  headshotRequests: Array<{ __typename?: 'HeadshotRequest'; id: string; createdAt: any }>
}

export type InterviewsToolbar_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type InterviewsToolbar_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{ __typename?: 'Interview'; id: string }>
}

export type JobPostingsToolbar_ExportCsvMutationVariables = Exact<{ [key: string]: never }>

export type JobPostingsToolbar_ExportCsvMutation = {
  __typename?: 'Mutation'
  exportUsersJobToCsv: string
}

export type ResumeBuilderToolbar_ArchiveResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type ResumeBuilderToolbar_ArchiveResumeMutation = {
  __typename?: 'Mutation'
  updateArchivedResume: { __typename?: 'Resumes'; id: string; archived: boolean }
}

export type ResumeBuilderToolbar_GetResumeQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilderToolbar_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    archived: boolean
    isPublic: boolean
    publicId: string
    name: string
  }>
}

export type ResumesToolbar_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ResumesToolbar_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UserNotificationsForm_JobSearchPreferenceFragment = {
  __typename?: 'JobSearchPreference'
  positions?: Array<string> | null
  locations?: Array<string> | null
  keywords?: Array<string> | null
  employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
  experienceLevels?: Array<JobListingExperienceLevelEnum> | null
  workArrangements?: Array<JobListingWorkArrangementEnum> | null
  datePosted?: JobListingDatePostedEnum | null
  educationRequirement?: JobListingEducationLevelEnum | null
  salaryMin?: number | null
  payPeriod?: JobListingPayPeriodEnum | null
  companyNumEmployeesMin?: number | null
  companyNumEmployeesMax?: number | null
  visaSponsorship?: boolean | null
}

export type UserNotificationsForm_JobSearchPreferenceQueryVariables = Exact<{
  [key: string]: never
}>

export type UserNotificationsForm_JobSearchPreferenceQuery = {
  __typename?: 'Query'
  jobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type UserNotificationsForm_UpsertJobSearchPreferenceMutationVariables = Exact<{
  attributes: JobSearchPreferenceInputObject
}>

export type UserNotificationsForm_UpsertJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  userUpsertJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type CreateResumeMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type CreateResumeMutation = {
  __typename?: 'Mutation'
  createResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type AuthResponseFragment = {
  __typename?: 'AuthResponse'
  token?: string | null
  isNewUser?: boolean | null
  user?: {
    __typename?: 'Users'
    id: string
    role: UsersRoleEnum
    hasCompletedOnboarding: boolean
  } | null
}

export type ProviderAuthenticationMutationVariables = Exact<{
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
}>

export type ProviderAuthenticationMutation = {
  __typename?: 'Mutation'
  authProviderAuthenticate: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationSignInMutationVariables = Exact<{
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationSignInMutation = {
  __typename?: 'Mutation'
  authSignIn: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationSignUpMutationVariables = Exact<{
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
}>

export type CredentialsAuthenticationSignUpMutation = {
  __typename?: 'Mutation'
  authSignUp: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationEmailVerifyMutationVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationEmailVerifyMutation = {
  __typename?: 'Mutation'
  userEmailVerify: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type ResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string }>
}

export type RootQueryVariables = Exact<{ [key: string]: never }>

export type RootQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    completedAllChecklistItems: boolean
    role: UsersRoleEnum
  }
  resumes: Array<{ __typename?: 'Resumes'; id: string }>
}

export type UploadResumeMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
  name: Scalars['String']['input']
}>

export type UploadResumeMutation = {
  __typename?: 'Mutation'
  uploadResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type JobListingsFragment = {
  __typename?: 'JobListings'
  id: string
  position: string
  companyName: string
  url?: string | null
  companyLogoUrl?: string | null
  companyIndustry?: string | null
  datePosted: any
  isRemote?: boolean | null
  location?: string | null
  salaryMax?: number | null
  salaryMin?: number | null
  salaryCurrency?: string | null
  employmentType?: JobListingEmploymentTypeEnum | null
  payPeriod?: JobListingPayPeriodEnum | null
}

export type JobListingsDetailsFragment = {
  __typename?: 'JobListings'
  id: string
  aiCoreResponsibilities?: string | null
  aiWorkArrangement?: JobListingWorkArrangementEnum | null
  aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
  aiRequirementsSummary?: string | null
  benefits: Array<string>
  companyDescription?: string | null
  companyDomain?: string | null
  companyIndustry?: string | null
  companyNumEmployees?: number | null
  companySpecialties: Array<string>
  companyLinkedinUrl?: string | null
  companyLogoUrl?: string | null
  employmentType?: JobListingEmploymentTypeEnum | null
  jobDetails?: string | null
  keySkills: Array<string>
  visaSponsorship: boolean
  workingHours?: number | null
  experienceLevelString?: string | null
  hiringManagerEmail?: string | null
  hiringManagerName?: string | null
  position: string
  companyName: string
  url?: string | null
  datePosted: any
  isRemote?: boolean | null
  location?: string | null
  salaryMax?: number | null
  salaryMin?: number | null
  salaryCurrency?: string | null
  payPeriod?: JobListingPayPeriodEnum | null
}

export type ResumesPreferencesFragment = {
  __typename?: 'ResumesPreferences'
  dateFormat: ResumesDateFormatEnum
  fontFamily: ResumesFontFamilyEnum
  fontSize: ResumesFontSizeEnum
  horizontalMargin: ResumesHorizontalMarginEnum
  verticalMargin: ResumesVerticalMarginEnum
  lineHeight: ResumesLineHeightEnum
  pageSize: ResumesPageSizeEnum
  sectionTitleCasing: ResumesSectionTitleCasingEnum
  sectionsOrder: Array<ResumeSortableSections>
  sectionsOrderWithCustomSections: Array<string>
  template: ResumesTemplateEnum
  templateColorEnum?: ResumesTemplateColorEnum | null
  hideCertifications: boolean
  hideCourseworks: boolean
  hideEducations: boolean
  hideInvolvements: boolean
  hideProjects: boolean
  hideSkills: boolean
  hideSummary: boolean
  hideWorkExperiences: boolean
  hideTargetTitle: boolean
  avatar: {
    __typename?: 'ResumesAvatarPreferences'
    profilePictureEnabled: boolean
    profilePictureShape?: ResumesProfilePictureShapeEnum | null
  }
}

export type ResumesFragment = {
  __typename?: 'Resumes'
  id: string
  uniqueId?: string | null
  createdAt: any
  updatedAt: any
  name: string
  archived: boolean
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  linkedinUrl?: string | null
  phoneNumber?: string | null
  professionalSummary?: string | null
  website?: string | null
  location?: string | null
  suggestedSkills: Array<string>
  documentUrl?: string | null
  documentType?: ResumeDocumentType | null
  showOriginalDocument: boolean
  hideEducations: boolean
  hideProjects: boolean
  hideSkills: boolean
  hideSummary: boolean
  hideCertifications: boolean
  hideWorkExperiences: boolean
  hideCourseworks: boolean
  hideInvolvements: boolean
  hideTargetTitle: boolean
  sectionsOrder: Array<ResumeSortableSections>
  targetTitle?: string | null
  template: ResumesTemplateEnum
  templateColorEnum?: ResumesTemplateColorEnum | null
  aiGenerated: boolean
  isPublic: boolean
  publicId: string
  tokenResumeAnalysis: number
  preferences: {
    __typename?: 'ResumesPreferences'
    dateFormat: ResumesDateFormatEnum
    fontFamily: ResumesFontFamilyEnum
    fontSize: ResumesFontSizeEnum
    horizontalMargin: ResumesHorizontalMarginEnum
    verticalMargin: ResumesVerticalMarginEnum
    lineHeight: ResumesLineHeightEnum
    pageSize: ResumesPageSizeEnum
    sectionTitleCasing: ResumesSectionTitleCasingEnum
    sectionsOrder: Array<ResumeSortableSections>
    sectionsOrderWithCustomSections: Array<string>
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    hideCertifications: boolean
    hideCourseworks: boolean
    hideEducations: boolean
    hideInvolvements: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideWorkExperiences: boolean
    hideTargetTitle: boolean
    avatar: {
      __typename?: 'ResumesAvatarPreferences'
      profilePictureEnabled: boolean
      profilePictureShape?: ResumesProfilePictureShapeEnum | null
    }
  }
  courseworks: Array<{
    __typename?: 'ResumesCoursework'
    id: string
    name?: string | null
    institutionName?: string | null
    endDate?: any | null
    achievements: Array<string>
    currentlyWorkingOnCourse: boolean
    showYearOnlyEndDate: boolean
  }>
  educations: Array<{
    __typename?: 'ResumesEducation'
    id: string
    additionalInformation?: string | null
    degree?: string | null
    endDate?: any | null
    startDate?: any | null
    gpa?: string | null
    institutionName: string
    location?: string | null
    currentlyInEducation: boolean
    achievements: Array<string>
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
  }>
  involvements: Array<{
    __typename?: 'ResumesInvolvement'
    id: string
    name?: string | null
    organizationName?: string | null
    startDate?: any | null
    endDate?: any | null
    achievements: Array<string>
    currentlyWorkingOnInvolvement: boolean
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
  }>
  projects: Array<{
    __typename?: 'ResumesProject'
    id: string
    achievements: Array<string>
    name: string
    endDate?: any | null
    startDate?: any | null
    currentlyWorkingOnProject: boolean
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
    linkUrl?: string | null
  }>
  workExperiences: Array<{
    __typename?: 'ResumesWorkExperience'
    id: string
    companyDescription?: string | null
    companyName: string
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    workPositions: Array<{
      __typename?: 'ResumesWorkPosition'
      id: string
      achievements: Array<string>
      location?: string | null
      name: string
      startDate?: any | null
      endDate?: any | null
      currentlyInPosition: boolean
      showYearOnlyStartDate: boolean
      showYearOnlyEndDate: boolean
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
    }>
  }>
  groupedSkills: Array<{
    __typename?: 'ResumesGroupedSkill'
    id: string
    category?: string | null
    skills: Array<string>
  }>
  simpleAnalysis: Array<{
    __typename?: 'FieldMessageType'
    field: string
    errorMessage?: string | null
  }>
  certifications: Array<{
    __typename?: 'ResumesCertification'
    id: string
    name: string
    completionDate?: any | null
    provider?: string | null
    showYearOnlyCompletionDate: boolean
  }>
  customSections: Array<{
    __typename?: 'ResumesCustomSection'
    id: string
    name: string
    customSectionExperiences: Array<{
      __typename?: 'ResumesCustomSectionExperience'
      id: string
      companyName?: string | null
      achievements: string
      currentlyInExperience: boolean
      endDate?: any | null
      location?: string | null
      name?: string | null
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      startDate?: any | null
    }>
  }>
}

export type UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  applicationInstructions?: string | null
  createdAt: any
  companyName: string
  isRemote?: boolean | null
  jobDetails?: string | null
  location?: string | null
  notes?: string | null
  payPeriod: UsersJobsPayPeriodEnum
  position: string
  salaryMax?: number | null
  salaryMin?: number | null
  status: UsersJobsStatusEnum
  updatedAt: any
  url?: string | null
  archived: boolean
  rejectedStage?: UsersJobsRejectedStageEnum | null
  interviewStep?: UsersJobsInterviewStepEnum | null
  numClientsApplied: number
  numClientsShared: number
  partnerArchived: boolean
  checklist: Array<{
    __typename?: 'UsersJobsChecklistItem'
    checklistEnum: UsersJobsChecklistEnum
    completed: boolean
  }>
  partnerCreatedByUser?: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
  contacts?: Array<{
    __typename?: 'Contacts'
    id: string
    email?: string | null
    name?: string | null
  }> | null
  resume?: { __typename?: 'Resumes'; id: string; name: string } | null
}

export type UseBillingPlan_SubscriptionSessionCreateMutationVariables = Exact<{
  plan: SubscriptionPlanEnum
  coupon?: InputMaybe<Scalars['String']['input']>
  isCreatedFromOnboarding?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UseBillingPlan_SubscriptionSessionCreateMutation = {
  __typename?: 'Mutation'
  subscriptionsSessionCreate: string
}

export type UseBillingPlan_BillingPortalUrlMutationVariables = Exact<{ [key: string]: never }>

export type UseBillingPlan_BillingPortalUrlMutation = {
  __typename?: 'Mutation'
  billingPortalUrl: string
}

export type UseBrowserExtensionToast_UserQueryVariables = Exact<{ [key: string]: never }>

export type UseBrowserExtensionToast_UserQuery = {
  __typename?: 'Query'
  user: { __typename?: 'Users'; id: string; usedChromeExtension: boolean }
}

export type UseCreateResume_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type UseCreateResume_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UsersFragment = {
  __typename?: 'Users'
  id: string
  uniqueId: string
  role: UsersRoleEnum
  email: string
  firstName?: string | null
  lastName?: string | null
  plan: SubscriptionPlanEnum
  activeResumesCount: number
  coverLetterCustomPrompt?: string | null
  hasCompletedResumeTour: boolean
  resumeSummaryCustomPrompt?: string | null
  resumeJobAchievementCustomPrompt?: string | null
  tokenCoverLetter: number
  tokenDownloadPdfs: number
  tokenInterviewQuestions: number
  tokenJobMatch: number
  tokenProfessionalSummary: number
  tokenSalaryInsights: number
  tokenLearnSkills: number
  tokenAchievements: number
  tokenInterview: number
  tokenWriter: number
  tokenOptimizeResume: number
  usedChromeExtension: boolean
  numUploadedResumes: number
  numStartedInterviews: number
  referralTokens: number
  hasSubscription: boolean
  isAdvisoryClient: boolean
  isAdvisoryOrgAccount: boolean
  profilePictureUrl?: string | null
  writingStyleEnum?: UsersWritingStyleEnum | null
  hasSeenGoldOnboarding: boolean
  hasCompletedOnboarding: boolean
  jobExperienceLevel?: JobListingExperienceLevelEnum | null
  targetJobTitle?: string | null
  createdAt: any
  location?: string | null
}

export type UseCurrentUser_UsersQueryVariables = Exact<{ [key: string]: never }>

export type UseCurrentUser_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    uniqueId: string
    role: UsersRoleEnum
    email: string
    firstName?: string | null
    lastName?: string | null
    plan: SubscriptionPlanEnum
    activeResumesCount: number
    coverLetterCustomPrompt?: string | null
    hasCompletedResumeTour: boolean
    resumeSummaryCustomPrompt?: string | null
    resumeJobAchievementCustomPrompt?: string | null
    tokenCoverLetter: number
    tokenDownloadPdfs: number
    tokenInterviewQuestions: number
    tokenJobMatch: number
    tokenProfessionalSummary: number
    tokenSalaryInsights: number
    tokenLearnSkills: number
    tokenAchievements: number
    tokenInterview: number
    tokenWriter: number
    tokenOptimizeResume: number
    usedChromeExtension: boolean
    numUploadedResumes: number
    numStartedInterviews: number
    referralTokens: number
    hasSubscription: boolean
    isAdvisoryClient: boolean
    isAdvisoryOrgAccount: boolean
    profilePictureUrl?: string | null
    writingStyleEnum?: UsersWritingStyleEnum | null
    hasSeenGoldOnboarding: boolean
    hasCompletedOnboarding: boolean
    jobExperienceLevel?: JobListingExperienceLevelEnum | null
    targetJobTitle?: string | null
    createdAt: any
    location?: string | null
  }
}

export type UseUploadResume_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type UseUploadResume_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UseUploadResume_RecentResumeUploadedMutationVariables = Exact<{ [key: string]: never }>

export type UseUploadResume_RecentResumeUploadedMutation = {
  __typename?: 'Mutation'
  resumeRecentUploaded?: { __typename?: 'Resumes'; id: string; name: string } | null
}

export type JobDetailsCard_CheckMatchLevelMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobDetailsCard_CheckMatchLevelMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: { __typename?: 'AmIAGoodFit'; overallMatch?: UsersJobsMatchEnum | null } | null
}

export type JobDetailsContainer_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobDetailsContainer_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: {
    __typename?: 'JobListings'
    id: string
    aiCoreResponsibilities?: string | null
    aiWorkArrangement?: JobListingWorkArrangementEnum | null
    aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
    aiRequirementsSummary?: string | null
    benefits: Array<string>
    companyDescription?: string | null
    companyDomain?: string | null
    companyIndustry?: string | null
    companyNumEmployees?: number | null
    companySpecialties: Array<string>
    companyLinkedinUrl?: string | null
    companyLogoUrl?: string | null
    employmentType?: JobListingEmploymentTypeEnum | null
    jobDetails?: string | null
    keySkills: Array<string>
    visaSponsorship: boolean
    workingHours?: number | null
    experienceLevelString?: string | null
    hiringManagerEmail?: string | null
    hiringManagerName?: string | null
    position: string
    companyName: string
    url?: string | null
    datePosted: any
    isRemote?: boolean | null
    location?: string | null
    salaryMax?: number | null
    salaryMin?: number | null
    salaryCurrency?: string | null
    payPeriod?: JobListingPayPeriodEnum | null
  }
  hasAddedJobListing?: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum } | null
}

export type JobDetailsContainer_AddJobListingToBookmarksMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}>

export type JobDetailsContainer_AddJobListingToBookmarksMutation = {
  __typename?: 'Mutation'
  bookmarkJob: {
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    url?: string | null
  }
}

export type JobSearchBar_CreateSearchFilterMutationVariables = Exact<{
  name: Scalars['String']['input']
  searchFilters: JobListingsFilterInputObject
}>

export type JobSearchBar_CreateSearchFilterMutation = {
  __typename?: 'Mutation'
  createSearchFilter: {
    __typename?: 'JobListingSavedSearch'
    id: string
    name: string
    searchFilters: {
      __typename?: 'JobListingsFilter'
      positions?: Array<string> | null
      companyName?: string | null
      companyNumEmployeesMin?: number | null
      companyNumEmployeesMax?: number | null
      employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
      workArrangements?: Array<JobListingWorkArrangementEnum> | null
      experienceLevels?: Array<JobListingExperienceLevelEnum> | null
      educationRequirements?: Array<JobListingEducationLevelEnum> | null
      keywords?: Array<string> | null
      keywordOr?: boolean | null
      taxonomies?: Array<string> | null
      experienceLevelMin?: number | null
      experienceLevelMax?: number | null
      datePosted?: JobListingDatePostedEnum | null
      datePostedMin?: any | null
      datePostedMax?: any | null
      foundedDate?: JobListingFoundedDateEnum | null
      salaryMin?: number | null
      payPeriod?: JobListingPayPeriodEnum | null
      visaSponsorship?: boolean | null
      skills?: Array<string> | null
      locations?: Array<{
        __typename?: 'JobListingsLocation'
        location: string
        useCityStateForLocation?: boolean | null
        radius?: number | null
      }> | null
    }
  }
}

export type JobSearchBar_UpdateSearchFilterMutationVariables = Exact<{
  id: Scalars['ID']['input']
  searchFilters: JobListingsFilterInputObject
}>

export type JobSearchBar_UpdateSearchFilterMutation = {
  __typename?: 'Mutation'
  updateSearchFilter: {
    __typename?: 'JobListingSavedSearch'
    id: string
    name: string
    searchFilters: {
      __typename?: 'JobListingsFilter'
      positions?: Array<string> | null
      companyName?: string | null
      companyNumEmployeesMin?: number | null
      companyNumEmployeesMax?: number | null
      employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
      workArrangements?: Array<JobListingWorkArrangementEnum> | null
      experienceLevels?: Array<JobListingExperienceLevelEnum> | null
      educationRequirements?: Array<JobListingEducationLevelEnum> | null
      keywords?: Array<string> | null
      keywordOr?: boolean | null
      taxonomies?: Array<string> | null
      experienceLevelMin?: number | null
      experienceLevelMax?: number | null
      datePosted?: JobListingDatePostedEnum | null
      datePostedMin?: any | null
      datePostedMax?: any | null
      foundedDate?: JobListingFoundedDateEnum | null
      salaryMin?: number | null
      payPeriod?: JobListingPayPeriodEnum | null
      visaSponsorship?: boolean | null
      skills?: Array<string> | null
      locations?: Array<{
        __typename?: 'JobListingsLocation'
        location: string
        useCityStateForLocation?: boolean | null
        radius?: number | null
      }> | null
    }
  }
}

export type LocationSearchInput_LocationsTypeaheadQueryVariables = Exact<{
  location: Scalars['String']['input']
}>

export type LocationSearchInput_LocationsTypeaheadQuery = {
  __typename?: 'Query'
  locationsTypeahead: Array<string>
}

export type LocationSearchInput_UserStoreLocationMutationVariables = Exact<{
  city: Scalars['String']['input']
  state: Scalars['String']['input']
}>

export type LocationSearchInput_UserStoreLocationMutation = {
  __typename?: 'Mutation'
  userStoreLocation: { __typename?: 'Users'; id: string }
}

export type SavedFilters_SavedFiltersQueryVariables = Exact<{ [key: string]: never }>

export type SavedFilters_SavedFiltersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    jobListingSavedSearches: Array<{
      __typename?: 'JobListingSavedSearch'
      id: string
      name: string
      searchFilters: {
        __typename?: 'JobListingsFilter'
        positions?: Array<string> | null
        companyName?: string | null
        companyNumEmployeesMin?: number | null
        companyNumEmployeesMax?: number | null
        employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
        workArrangements?: Array<JobListingWorkArrangementEnum> | null
        experienceLevels?: Array<JobListingExperienceLevelEnum> | null
        educationRequirements?: Array<JobListingEducationLevelEnum> | null
        keywords?: Array<string> | null
        keywordOr?: boolean | null
        taxonomies?: Array<string> | null
        experienceLevelMin?: number | null
        experienceLevelMax?: number | null
        datePosted?: JobListingDatePostedEnum | null
        datePostedMin?: any | null
        datePostedMax?: any | null
        foundedDate?: JobListingFoundedDateEnum | null
        salaryMin?: number | null
        payPeriod?: JobListingPayPeriodEnum | null
        visaSponsorship?: boolean | null
        skills?: Array<string> | null
        locations?: Array<{
          __typename?: 'JobListingsLocation'
          location: string
          useCityStateForLocation?: boolean | null
          radius?: number | null
        }> | null
      }
    }>
  }
}

export type ResumeBuilderV2_UpdateResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilderV2_UpdateResumeMutation = {
  __typename?: 'Mutation'
  updateResume: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilderV2_UpdateResumePreferencesMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumePreferencesInputObject
}>

export type ResumeBuilderV2_UpdateResumePreferencesMutation = {
  __typename?: 'Mutation'
  updateResumePreferences: { __typename?: 'Resumes'; id: string }
}

export type ResumeBuilderV2_UpdateResumeTourCompletedMutationVariables = Exact<{
  hasCompletedResumeTour: Scalars['Boolean']['input']
}>

export type ResumeBuilderV2_UpdateResumeTourCompletedMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string }
}

export type ResumeBuilderV2_ScoreResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilderV2_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type ResumeBuilderV2_DownloadPdfMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilderV2_DownloadPdfMutation = {
  __typename?: 'Mutation'
  downloadPdfResume: { __typename?: 'Resumes'; id: string }
}

export type ViewerPanel_UpdateResumePdfBlobMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  pdfBlob: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type ViewerPanel_UpdateResumePdfBlobMutation = {
  __typename?: 'Mutation'
  updatePdfBlob: { __typename?: 'Resumes'; id: string }
}

export type GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutationVariables = Exact<{
  achievementStrings: Array<Scalars['String']['input']> | Scalars['String']['input']
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutation = {
  __typename?: 'Mutation'
  generateJobAchievementFromString: Array<string>
}

export type GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  useExisting: Scalars['Boolean']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutation = {
  __typename?: 'Mutation'
  generateProfessionalSummary: string
}

export type ResumeAnalyzerToolkitSection_AnalyzeResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
}>

export type ResumeAnalyzerToolkitSection_AnalyzeResumeMutation = {
  __typename?: 'Mutation'
  resumeRelevanceAnalysis: {
    __typename?: 'ResumesResumeRelevanceAnalysis'
    isSummaryRelevantForJobTitle: boolean
    relevantSummaryForJobTitle?: string | null
    suggestedSkillsForJobTitle: Array<string>
    originalSummary?: string | null
    irrelevantSkillsForJobTitle: Array<{
      __typename?: 'ResumesAnalysisSkillType'
      category?: string | null
      skill: string
    }>
    irrelevantAchievementsForJobTitle: Array<{
      __typename?: 'ResumesIrrelevantAchievementType'
      achievementIndex: number
      achievementType: ResumesResumeAchievementTypeEnum
      achievementTypeId: number
      companyName?: string | null
      irrelevantAchievementForJobTitle: string
      position?: string | null
      relevantAchievementForJobTitle: string
    }>
  }
}

export type ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  achievementsToUpdate?: InputMaybe<
    Array<ResumesRelevantAchievementInputObject> | ResumesRelevantAchievementInputObject
  >
  skillsToAdd?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  skillsToRemove?: InputMaybe<
    Array<ResumesAnalysisSkillTypeInputObject> | ResumesAnalysisSkillTypeInputObject
  >
  summary?: InputMaybe<Scalars['String']['input']>
}>

export type ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutation = {
  __typename?: 'Mutation'
  fixFromRelevanceAnalysis: {
    __typename?: 'Resumes'
    id: string
    professionalSummary?: string | null
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
  }
}

export type ResumeAnalyzerToolkitSection_GetResumeQueryVariables = Exact<{
  resumeID: Scalars['ID']['input']
}>

export type ResumeAnalyzerToolkitSection_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    tokenResumeAnalysis: number
    lastAnalyzedAt?: any | null
  }>
}

export type ResumeScorerTookitSection_ScoreResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeScorerTookitSection_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type ResumeBuilder_GetResumeQueryVariables = Exact<{
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumeBuilder_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    documentUrl?: string | null
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumeBuilder_GetResumeUnauthenticatedQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilder_GetResumeUnauthenticatedQuery = {
  __typename?: 'Query'
  resumeUnauthenticated?: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  } | null
}

export type ResumeBuilder_GetClientResumeQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumeBuilder_GetClientResumeQuery = {
  __typename?: 'Query'
  clientResumes: Array<{
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumeBuilder_PublicResumeQueryVariables = Exact<{
  publicId: Scalars['ID']['input']
}>

export type ResumeBuilder_PublicResumeQuery = {
  __typename?: 'Query'
  publicResume?: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  } | null
}

export type ResumeBuilder_CreateResumeUnauthenticatedMutationVariables = Exact<{
  attributes?: InputMaybe<ResumesInputObject>
}>

export type ResumeBuilder_CreateResumeUnauthenticatedMutation = {
  __typename?: 'Mutation'
  createResumeUnauthenticated: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_UpdateResumeUnauthenticatedMutationVariables = Exact<{
  resumeUniqueId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilder_UpdateResumeUnauthenticatedMutation = {
  __typename?: 'Mutation'
  updateResumeUnauthenticated: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_UpdateResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilder_UpdateResumeMutation = {
  __typename?: 'Mutation'
  updateResume: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_DownloadPdfMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilder_DownloadPdfMutation = {
  __typename?: 'Mutation'
  downloadPdfResume: { __typename?: 'Resumes'; id: string }
}

export type ResumeBuilder_ScoreResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilder_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type Plan_SubscriptionSessionFetchMutationVariables = Exact<{
  sessionId: Scalars['ID']['input']
}>

export type Plan_SubscriptionSessionFetchMutation = {
  __typename?: 'Mutation'
  subscriptionsSessionFetch: string
}

export type Plan_CompleteOnboardingMutationVariables = Exact<{ [key: string]: never }>

export type Plan_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; hasCompletedOnboarding: boolean }
}

export type Plan_RequestResumeSuccessMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
}>

export type Plan_RequestResumeSuccessMutation = {
  __typename?: 'Mutation'
  subscriptionsRequestResumeSuccess: string
}

export const ApplicationChartContent_UsersJobsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationChartContent_UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationChartContent_UsersJobsFragment, unknown>
export const UserJobsActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserJobsActivity' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserJobsActivityFragment, unknown>
export const ApplicationDetailsPanel_UsersJobsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationDetailsPanel_UsersJobsFragment, unknown>
export const CompanyDetails_UsersJobsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyDetails_UsersJobsFragment, unknown>
export const InterviewingDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InterviewingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InterviewingDetailsFragment, unknown>
export const PositionDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PositionDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PositionDetailsFragment, unknown>
export const CoverLetterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoverLetter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UsersJobsCoverLetterType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentUsedResumeForGenerate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoverLetterFragment, unknown>
export const Interviews_InterviewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Interviews_interview' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Interview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Interviews_InterviewFragment, unknown>
export const ResumesList_ResumesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesList_resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesList_ResumesFragment, unknown>
export const ApplicationSelect_UsersJobsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationSelect_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationSelect_UsersJobsFragment, unknown>
export const TodoTaskUsersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskUsers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedJobAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedResumeAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numJobs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobsAddedThisWeek' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobsToFollowUp' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thankYouJobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoTaskUsersFragment, unknown>
export const TodoTaskResumesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskResumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoTaskResumesFragment, unknown>
export const UsersUpdateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobNotifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobRecommendationsNotifications' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersUpdateFragment, unknown>
export const AccountSettingsDialog_JobSearchPreferenceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountSettingsDialog_JobSearchPreferenceFragment, unknown>
export const CreateClientGroupDialog_ClientGroupFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_clientGroup' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientGroupDialog_ClientGroupFragment, unknown>
export const UserNotificationsForm_JobSearchPreferenceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserNotificationsForm_JobSearchPreferenceFragment, unknown>
export const AuthResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthResponseFragment, unknown>
export const JobListingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobListingsFragment, unknown>
export const JobListingsDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListingsDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiCoreResponsibilities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiWorkArrangement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiEducationRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiRequirementsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'benefits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployees' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySpecialties' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLinkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keySkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workingHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelString' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerName' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListings' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobListingsDetailsFragment, unknown>
export const ResumesPreferencesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesPreferencesFragment, unknown>
export const ResumesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesFragment, unknown>
export const UsersJobsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersJobsFragment, unknown>
export const UsersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Users' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeResumesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coverLetterCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedResumeTour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeSummaryCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeJobAchievementCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenCoverLetter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenDownloadPdfs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterviewQuestions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenJobMatch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenProfessionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenSalaryInsights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenLearnSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenAchievements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenWriter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenOptimizeResume' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numUploadedResumes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numStartedInterviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralTokens' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSubscription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryOrgAccount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writingStyleEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSeenGoldOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobExperienceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersFragment, unknown>
export const AdvisorsList_AdvisorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdvisorsList_advisors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersRoleEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AdvisorSortEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortByDirectionEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'advisors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortByDirection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobsShared' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobsAdded' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numOwnClients' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Users' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Users' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeResumesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coverLetterCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedResumeTour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeSummaryCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeJobAchievementCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenCoverLetter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenDownloadPdfs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterviewQuestions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenJobMatch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenProfessionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenSalaryInsights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenLearnSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenAchievements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenWriter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenOptimizeResume' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numUploadedResumes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numStartedInterviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralTokens' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSubscription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryOrgAccount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writingStyleEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSeenGoldOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobExperienceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdvisorsList_AdvisorsQuery, AdvisorsList_AdvisorsQueryVariables>
export const ClientGroupClientContent_ClientGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientGroupClientContent_clientGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientGroupClientContent_ClientGroupsQuery,
  ClientGroupClientContent_ClientGroupsQueryVariables
>
export const ClientGroupClientList_ClientGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientGroupClientList_clientGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numAllJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numInterviewedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numOfferedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numRejectedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numAppliedJobs' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastActiveAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'advisor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientGroupClientList_ClientGroupsQuery,
  ClientGroupClientList_ClientGroupsQueryVariables
>
export const ClientBoard_ClientUsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientBoard_clientUsersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientUsersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientBoard_ClientUsersJobsQuery,
  ClientBoard_ClientUsersJobsQueryVariables
>
export const ClientContent_ClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientContent_client' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActiveAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersJobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeResumes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientContent_ClientQuery, ClientContent_ClientQueryVariables>
export const ClientResumes_ClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientResumes_client' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeResumes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientResumes_ClientQuery, ClientResumes_ClientQueryVariables>
export const ClientsList_ClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientsList_clients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'advisorIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'advisorIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'advisorIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numAllJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numAppliedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numInterviewedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numOfferedJobs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numRejectedJobs' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastActiveAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'advisor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientsList_ClientsQuery, ClientsList_ClientsQueryVariables>
export const JobPostingsList_JobPostingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobPostingsList_jobPostings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JobPostingSortEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortByDirectionEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedUsersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortByDirection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clientsShared' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobPostingsList_JobPostingsQuery,
  JobPostingsList_JobPostingsQueryVariables
>
export const JobPostingsList_UpdateUsersJobArchivedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobPostingsList_updateUsersJobArchived' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobPostingsList_UpdateUsersJobArchivedMutation,
  JobPostingsList_UpdateUsersJobArchivedMutationVariables
>
export const ApplicationChartContent_UsersJobsDateRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationChartContent_usersJobsDateRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobsDateRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'numAllJobs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numAppliedJobs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numInterviewedJobs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numOfferedJobs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numRejectedJobs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allJobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApplicationChartContent_UsersJobs' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliedJobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApplicationChartContent_UsersJobs' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interviewedJobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ApplicationChartContent_UsersJobs' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationChartContent_UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationChartContent_UsersJobsDateRangeQuery,
  ApplicationChartContent_UsersJobsDateRangeQueryVariables
>
export const ActivityTab_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityTab_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersJobActivities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityTab_UsersJobsQuery, ActivityTab_UsersJobsQueryVariables>
export const ApplicationDetailsPanel_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailsPanel_UsersJobsQuery,
  ApplicationDetailsPanel_UsersJobsQueryVariables
>
export const ApplicationDetailsPanel_GenerateCompanyDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicationDetailsPanel_generateCompanyDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCompanyDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationDetailsPanel_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailsPanel_GenerateCompanyDomainMutation,
  ApplicationDetailsPanel_GenerateCompanyDomainMutationVariables
>
export const ApplicationNotes_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationNotes_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationNotes_UsersJobsQuery,
  ApplicationNotes_UsersJobsQueryVariables
>
export const ApplicationNotes_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicationNotes_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationNotes_UpdateUsersJobMutation,
  ApplicationNotes_UpdateUsersJobMutationVariables
>
export const ApplicationsOverview_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationsOverview_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationsOverview_UsersJobsQuery,
  ApplicationsOverview_UsersJobsQueryVariables
>
export const ApplicationsOverview_GenerateMessageForContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicationsOverview_generateMessageForContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessagesMessageType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactRelationship' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessagesContactType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateMessageForContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'messageType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactRelationship' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactRelationship' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationsOverview_GenerateMessageForContactMutation,
  ApplicationsOverview_GenerateMessageForContactMutationVariables
>
export const CompanyActionBar_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyActionBar_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchLevel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyActionBar_UsersJobsQuery,
  CompanyActionBar_UsersJobsQueryVariables
>
export const CompanyContactsOverview_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyContactsOverview_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyContactsOverview_UsersJobsQuery,
  CompanyContactsOverview_UsersJobsQueryVariables
>
export const CompanyContactsOverview_GetLinkedinConnectionsUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyContactsOverview_getLinkedinConnectionsUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLinkedinConnectionsUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyContactsOverview_GetLinkedinConnectionsUrlQuery,
  CompanyContactsOverview_GetLinkedinConnectionsUrlQueryVariables
>
export const CompanyContactsOverview_NetworkingPeopleFromUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyContactsOverview_networkingPeopleFromUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkingPeopleFromUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'matchTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedinProfilePictureUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'school' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'degreeName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldOfStudy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'experience' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyLinkedinProfileUrl' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyContactsOverview_NetworkingPeopleFromUsersJobQuery,
  CompanyContactsOverview_NetworkingPeopleFromUsersJobQueryVariables
>
export const CompanyDetails_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyDetails_UsersJobsQuery, CompanyDetails_UsersJobsQueryVariables>
export const CompanyDetails_GenerateCompanyDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompanyDetails_generateCompanyDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCompanyDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyDetails_GenerateCompanyDomainMutation,
  CompanyDetails_GenerateCompanyDomainMutationVariables
>
export const CompanyDetails_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompanyDetails_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyDomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyDetails_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyDetails_UpdateUsersJobMutation,
  CompanyDetails_UpdateUsersJobMutationVariables
>
export const CompanyInsightsOverview_GetLatestCompanyInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyInsightsOverview_getLatestCompanyInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLatestCompanyInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'accomplishmentsAndAnnouncementsAndProductReleases',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'companyCultureAndPractices' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'competitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'missionAndVisionOfCompany' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maximumSalary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minimumSalary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expectedSalaryMessage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fundingsRounds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'growthFinancialNumbers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyInsightsOverview_GetLatestCompanyInfoQuery,
  CompanyInsightsOverview_GetLatestCompanyInfoQueryVariables
>
export const CompanyInsightsOverview_GetGlassdoorResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyInsightsOverview_getGlassdoorResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGlassdoorResults' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyInsightsOverview_GetGlassdoorResultsQuery,
  CompanyInsightsOverview_GetGlassdoorResultsQueryVariables
>
export const GlassdoorResultsSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'glassdoorResultsSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glassdoor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'whatProsUsersAreSaying' } },
                { kind: 'Field', name: { kind: 'Name', value: 'whatConsUsersAreSaying' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'whatConsUsersAreSayingAboutPosition' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'whatProsUsersAreSayingAboutPosition' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'usersJobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GlassdoorResultsSubscriptionSubscription,
  GlassdoorResultsSubscriptionSubscriptionVariables
>
export const CompanyOverview_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyOverview_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyOverview_UsersJobsQuery,
  CompanyOverview_UsersJobsQueryVariables
>
export const CompanyOverview_GetAboutCompanyInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyOverview_getAboutCompanyInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAboutCompanyInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'foundedYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinCompanyUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfEmployeeRangeMax' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfEmployeeRangeMin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyOverview_GetAboutCompanyInfoQuery,
  CompanyOverview_GetAboutCompanyInfoQueryVariables
>
export const DocumentsTab_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentsTab_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resume' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverLetter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentsTab_UsersJobsQuery, DocumentsTab_UsersJobsQueryVariables>
export const InterviewingDetails_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InterviewingDetails_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InterviewingDetails' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InterviewingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterviewingDetails_UsersJobsQuery,
  InterviewingDetails_UsersJobsQueryVariables
>
export const InterviewingDetails_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InterviewingDetails_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appliedAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewedAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsInterviewStepEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsRejectedStageEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appliedAt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appliedAt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewedAt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewedAt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewStep' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rejectedStage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InterviewingDetails' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InterviewingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterviewingDetails_UpdateUsersJobMutation,
  InterviewingDetails_UpdateUsersJobMutationVariables
>
export const LearnSkills_LearnSkillsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LearnSkills_learnSkills' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learnSkills' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSync' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LearnSkills_LearnSkillsMutation,
  LearnSkills_LearnSkillsMutationVariables
>
export const LearnSkillsSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'LearnSkillsSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learnSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usersJobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'i' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LearnSkillsSubscriptionSubscription,
  LearnSkillsSubscriptionSubscriptionVariables
>
export const MatchScore_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatchScore_resumes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupedSkills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'skills' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MatchScore_ResumesQuery, MatchScore_ResumesQueryVariables>
export const MatchScore_AmIaGoodFitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MatchScore_amIAGoodFit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDescription' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amIAGoodFit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDescription' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDescription' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'overallSummary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overallMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantEducationMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantExperience' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantExperienceMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantSkills' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantSkillsMatch' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MatchScore_AmIaGoodFitMutation,
  MatchScore_AmIaGoodFitMutationVariables
>
export const NextStepsChecklist_GetChecklistDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NextStepsChecklist_getChecklist' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NextStepsChecklist_GetChecklistQuery,
  NextStepsChecklist_GetChecklistQueryVariables
>
export const NextStepsChecklist_UpdateChecklistDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NextStepsChecklist_updateChecklist' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appliedChecklistCompleted' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsChecklistEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'interviewChecklistCompleted' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsChecklistEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'wishlistChecklistCompleted' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsChecklistEnum' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appliedChecklistCompleted' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appliedChecklistCompleted' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewChecklistCompleted' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'interviewChecklistCompleted' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'wishlistChecklistCompleted' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'wishlistChecklistCompleted' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NextStepsChecklist_UpdateChecklistMutation,
  NextStepsChecklist_UpdateChecklistMutationVariables
>
export const PositionDetails_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PositionDetails_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PositionDetails' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PositionDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PositionDetails_UsersJobsQuery,
  PositionDetails_UsersJobsQueryVariables
>
export const PositionDetails_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PositionDetails_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsPayPeriodEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isRemote' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'location' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payPeriod' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMax' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PositionDetails' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PositionDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PositionDetails_UpdateUsersJobMutation,
  PositionDetails_UpdateUsersJobMutationVariables
>
export const SalaryInsights_SalaryInsightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalaryInsights_salaryInsights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salaryInsights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SalaryInsights_SalaryInsightsMutation,
  SalaryInsights_SalaryInsightsMutationVariables
>
export const ApplicationContent_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationContent_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserJobsActivity' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenSalaryInsights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenJobMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenLearnSkills' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenAchievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserJobsActivity' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationContent_UsersJobsQuery,
  ApplicationContent_UsersJobsQueryVariables
>
export const ApplicationContent_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicationContent_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationInstructions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsPayPeriodEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsRejectedStageEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsInterviewStepEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationInstructions' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applicationInstructions' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isRemote' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'location' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payPeriod' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMax' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rejectedStage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewStep' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserJobsActivity' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserJobsActivity' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationContent_UpdateUsersJobMutation,
  ApplicationContent_UpdateUsersJobMutationVariables
>
export const Applications_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Applications_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Applications_UsersJobsQuery, Applications_UsersJobsQueryVariables>
export const Applications_GetMatchLevelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Applications_getMatchLevels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matchLevel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Applications_GetMatchLevelsQuery,
  Applications_GetMatchLevelsQueryVariables
>
export const Applications_UpdateUsersJobStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Applications_updateUsersJobStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Applications_UpdateUsersJobStatusMutation,
  Applications_UpdateUsersJobStatusMutationVariables
>
export const Applications_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Applications_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Applications_UpdateUsersJobMutation,
  Applications_UpdateUsersJobMutationVariables
>
export const CoverLetterContent_CoverLettersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoverLetterContent_coverLetters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coverLetterIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoverLetter' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoverLetter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UsersJobsCoverLetterType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentUsedResumeForGenerate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLetterContent_CoverLettersQuery,
  CoverLetterContent_CoverLettersQueryVariables
>
export const CoverLettercontent_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoverLettercontent_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLettercontent_ResumesQuery,
  CoverLettercontent_ResumesQueryVariables
>
export const CoverLetterContent_GenerateCoverLetterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CoverLetterContent_generateCoverLetter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterLength' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CoverLetterLengthEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterTone' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CoverLetterToneEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCoverLetter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coverLetterLength' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterLength' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coverLetterTone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterTone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLetterContent_GenerateCoverLetterMutation,
  CoverLetterContent_GenerateCoverLetterMutationVariables
>
export const CoverLetterContent_CoverLetterUpsertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CoverLetterContent_coverLetterUpsert' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UsersJobsCoverLetterInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetterUpsert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoverLetter' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoverLetter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UsersJobsCoverLetterType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentUsedResumeForGenerate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLetterContent_CoverLetterUpsertMutation,
  CoverLetterContent_CoverLetterUpsertMutationVariables
>
export const CoverLettersList_CoverLettersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoverLettersList_coverLetters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLettersList_CoverLettersQuery,
  CoverLettersList_CoverLettersQueryVariables
>
export const ListEmpty_CreateResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListEmpty_createResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListEmpty_CreateResumeMutation,
  ListEmpty_CreateResumeMutationVariables
>
export const HeadshotsList_AllHeadshotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeadshotsList_allHeadshots' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headshotRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HeadshotsList_AllHeadshotsQuery,
  HeadshotsList_AllHeadshotsQueryVariables
>
export const Interview_GetInterviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Interview_getInterview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviews' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fromUser' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Interview_GetInterviewQuery, Interview_GetInterviewQueryVariables>
export const InterviewsSidebar_InterviewsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InterviewsSidebar_interviews' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterviewsSidebar_InterviewsQuery,
  InterviewsSidebar_InterviewsQueryVariables
>
export const Interviews_InterviewsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Interviews_interviews' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Interviews_InterviewsQuery, Interviews_InterviewsQueryVariables>
export const Interviews_InterviewAddMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Interviews_interviewAddMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviewAddMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'message' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Interviews_interview' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Interviews_interview' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Interview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fromUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Interviews_InterviewAddMessageMutation,
  Interviews_InterviewAddMessageMutationVariables
>
export const JobSearchDetailsPage_GetJobListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobSearchDetailsPage_getJobListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListingsDetails' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasAddedJobListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListingsDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiCoreResponsibilities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiWorkArrangement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiEducationRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiRequirementsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'benefits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployees' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySpecialties' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLinkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keySkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workingHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelString' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerName' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobSearchDetailsPage_GetJobListingQuery,
  JobSearchDetailsPage_GetJobListingQueryVariables
>
export const JobSearchResultsPage_PaginatedJobListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobSearchResultsPage_paginatedJobListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'JobListingsFilterInputObject' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListingsSortEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortByDirectionEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedJobListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortByDirection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListings' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobSearchResultsPage_PaginatedJobListingsQuery,
  JobSearchResultsPage_PaginatedJobListingsQueryVariables
>
export const JobPage_GetJobListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobPage_getJobListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobPage_GetJobListingQuery, JobPage_GetJobListingQueryVariables>
export const ResumePage_GetResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumePage_getResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumePage_GetResumeQuery, ResumePage_GetResumeQueryVariables>
export const ResumesList_AllResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumesList_allResumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesList_AllResumesQuery, ResumesList_AllResumesQueryVariables>
export const ResumesList_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumesList_resumes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'aiGenerated' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'aiGeneratedForJobTitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'aiGenerated' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'aiGenerated' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'aiGeneratedForJobTitle' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'aiGeneratedForJobTitle' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesList_resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesList_resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesList_ResumesQuery, ResumesList_ResumesQueryVariables>
export const ResumeList_UpdateArchivedResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeList_updateArchivedResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateArchivedResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesList_resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesList_resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeList_UpdateArchivedResumeMutation,
  ResumeList_UpdateArchivedResumeMutationVariables
>
export const ResumeList_DuplicateResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeList_duplicateResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesList_resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesList_resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeList_DuplicateResumeMutation,
  ResumeList_DuplicateResumeMutationVariables
>
export const RoastResume_RoastResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RoastResume_roastResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RoastRoleTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toneLevel' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RoastToneLevelEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roastResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toneLevel' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toneLevel' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoastResume_RoastResumeMutation,
  RoastResume_RoastResumeMutationVariables
>
export const RoastSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'RoastSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roast' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'i' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoastSubscriptionSubscription, RoastSubscriptionSubscriptionVariables>
export const ForgotPassword_AuthPasswordResetRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ForgotPassword_authPasswordResetRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authPasswordResetRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotPassword_AuthPasswordResetRequestMutation,
  ForgotPassword_AuthPasswordResetRequestMutationVariables
>
export const ResetPassword_ResetPasswordAllowedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResetPassword_resetPasswordAllowed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPasswordAllowed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resetPasswordToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPassword_ResetPasswordAllowedQuery,
  ResetPassword_ResetPasswordAllowedQueryVariables
>
export const ResetPassword_ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPassword_resetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'newPassword' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authResetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resetPasswordToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'newPassword' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPassword_ResetPasswordMutation,
  ResetPassword_ResetPasswordMutationVariables
>
export const EmailVerify_EmailVerifyAllowedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EmailVerify_emailVerifyAllowed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailVerifyAllowed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailVerificationCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmailVerify_EmailVerifyAllowedQuery,
  EmailVerify_EmailVerifyAllowedQueryVariables
>
export const ExperienceLevelPage_UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExperienceLevelPage_updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobExperienceLevel' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobListingExperienceLevelEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobExperienceLevel' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobExperienceLevel' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobExperienceLevel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExperienceLevelPage_UpdateUserMutation,
  ExperienceLevelPage_UpdateUserMutationVariables
>
export const OnboardingFlow_CompleteOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OnboardingFlow_completeOnboarding' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasCompletedOnboarding' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardingFlow_CompleteOnboardingMutation,
  OnboardingFlow_CompleteOnboardingMutationVariables
>
export const ResumePage_GetResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumePage_getResumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumePage_GetResumesQuery, ResumePage_GetResumesQueryVariables>
export const WelcomePage_UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WelcomePage_updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'targetJobTitle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetJobTitle' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WelcomePage_UpdateUserMutation,
  WelcomePage_UpdateUserMutationVariables
>
export const ApplicationSelect_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationSelect_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicationSelect_usersJobs' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicationSelect_usersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationSelect_UsersJobsQuery,
  ApplicationSelect_UsersJobsQueryVariables
>
export const Feedback_FeedbackCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Feedback_feedbackCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subject' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feedback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Feedback_FeedbackCreateMutation,
  Feedback_FeedbackCreateMutationVariables
>
export const GoldOnboardingManager_CompleteOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GoldOnboardingManager_completeOnboarding' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasSeenGoldOnboarding' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GoldOnboardingManager_CompleteOnboardingMutation,
  GoldOnboardingManager_CompleteOnboardingMutationVariables
>
export const Navigation_GetTodoTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Navigation_getTodoTasks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TodoTaskUsers' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TodoTaskResumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskUsers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedJobAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedResumeAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numJobs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobsAddedThisWeek' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobsToFollowUp' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thankYouJobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskResumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Navigation_GetTodoTasksQuery, Navigation_GetTodoTasksQueryVariables>
export const Navigation_ClientGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Navigation_clientGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Navigation_ClientGroupsQuery, Navigation_ClientGroupsQueryVariables>
export const ResumesSelect_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumesSelect_resumes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesSelect_ResumesQuery, ResumesSelect_ResumesQueryVariables>
export const TodoTasks_GetTodoTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TodoTasks_getTodoTasks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TodoTaskUsers' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TodoTaskResumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskUsers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedJobAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedResumeAiFeature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numJobs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobsAddedThisWeek' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobsToFollowUp' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appliedAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thankYouJobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TodoTaskResumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoTasks_GetTodoTasksQuery, TodoTasks_GetTodoTasksQueryVariables>
export const UpdateLastPageLoaded_UpdateLastPageLoadedAtDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLastPageLoaded_updateLastPageLoadedAt' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLastPageLoadedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLastPageLoaded_UpdateLastPageLoadedAtMutation,
  UpdateLastPageLoaded_UpdateLastPageLoadedAtMutationVariables
>
export const AccountSettingsDialog_UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsDialog_user' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersUpdate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobNotifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobRecommendationsNotifications' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UserQuery,
  AccountSettingsDialog_UserQueryVariables
>
export const AccountSettingsDialog_UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersInputObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersUpdate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobNotifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobRecommendationsNotifications' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UpdateUserMutation,
  AccountSettingsDialog_UpdateUserMutationVariables
>
export const AccountSettingsDialog_UserUploadProfilePictureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_userUploadProfilePicture' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUploadProfilePicture' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersUpdate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobNotifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJobRecommendationsNotifications' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UserUploadProfilePictureMutation,
  AccountSettingsDialog_UserUploadProfilePictureMutationVariables
>
export const AccountSettingsDialog_JobSearchPreferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobSearchPreference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_JobSearchPreferenceQuery,
  AccountSettingsDialog_JobSearchPreferenceQueryVariables
>
export const AccountSettingsDialog_UpsertJobSearchPreferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_UpsertJobSearchPreference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobSearchPreferenceInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpsertJobSearchPreference' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountSettingsDialog_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UpsertJobSearchPreferenceMutation,
  AccountSettingsDialog_UpsertJobSearchPreferenceMutationVariables
>
export const CreateClientGroupDialog_CreateClientGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_createClientGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CreateClientGroupDialog_clientGroup' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_clientGroup' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClientGroupDialog_CreateClientGroupMutation,
  CreateClientGroupDialog_CreateClientGroupMutationVariables
>
export const CreateClientGroupDialog_AddUsersToClientGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_addUsersToClientGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addUsersToClientGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CreateClientGroupDialog_clientGroup' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_clientGroup' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClientGroupDialog_AddUsersToClientGroupMutation,
  CreateClientGroupDialog_AddUsersToClientGroupMutationVariables
>
export const CreateClientGroupDialog_ClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateClientGroupDialog_clients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClientGroupDialog_ClientsQuery,
  CreateClientGroupDialog_ClientsQueryVariables
>
export const DidYouApplyJobListingDialog_ApplyJobListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DidYouApplyJobListingDialog_applyJobListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markJobListingAsApplied' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DidYouApplyJobListingDialog_ApplyJobListingMutation,
  DidYouApplyJobListingDialog_ApplyJobListingMutationVariables
>
export const EditClientGroupDialog_ClientGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EditClientGroupDialog_clientGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditClientGroupDialog_ClientGroupsQuery,
  EditClientGroupDialog_ClientGroupsQueryVariables
>
export const EditClientGroupDialog_ClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EditClientGroupDialog_clients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditClientGroupDialog_ClientsQuery,
  EditClientGroupDialog_ClientsQueryVariables
>
export const EditClientGroupDialog_EditClientGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditClientGroupDialog_editClientGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editClientGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditClientGroupDialog_EditClientGroupMutation,
  EditClientGroupDialog_EditClientGroupMutationVariables
>
export const EnhanceAchievementDialog_GenerateOneJobAchievementDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnhanceAchievementDialog_generateOneJobAchievement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workPositionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'index' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateOneJobAchievement' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'workPositionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'workPositionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'index' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'index' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnhanceAchievementDialog_GenerateOneJobAchievementMutation,
  EnhanceAchievementDialog_GenerateOneJobAchievementMutationVariables
>
export const EnhanceSummaryDialog_GenerateProfessionalSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnhanceSummaryDialog_generateProfessionalSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useExisting' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateProfessionalSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useExisting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useExisting' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnhanceSummaryDialog_GenerateProfessionalSummaryMutation,
  EnhanceSummaryDialog_GenerateProfessionalSummaryMutationVariables
>
export const FeedbackDialog_CreateFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FeedbackDialog_createFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subject' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feedback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FeedbackDialog_CreateFeedbackMutation,
  FeedbackDialog_CreateFeedbackMutationVariables
>
export const GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'GenerateSimilarProfileMessageDialog_generateDraftEmailForSimilarProfile',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'similarProfile' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SimilarProfilesInputObject' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'forHiringManager' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'forRecruiter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateDraftEmailForSimilarProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'forHiringManager' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'forHiringManager' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'forRecruiter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'forRecruiter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'similarProfile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'similarProfile' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutation,
  GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutationVariables
>
export const GoldOnboardingDialog_UserUpdateWritingStyleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GoldOnboardingDialog_userUpdateWritingStyle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'writingStyle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersWritingStyleEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpdateWritingStyle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'writingStyleEnum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'writingStyle' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GoldOnboardingDialog_UserUpdateWritingStyleMutation,
  GoldOnboardingDialog_UserUpdateWritingStyleMutationVariables
>
export const ImportResumeFromLinkedinDialog_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportResumeFromLinkedinDialog_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportResumeFromLinkedinDialog_ResumesQuery,
  ImportResumeFromLinkedinDialog_ResumesQueryVariables
>
export const ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportResumeFromLinkedinDialog_createResumeFromLinkedinUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResumeFromLinkedinUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'linkedinProfileUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutation,
  ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutationVariables
>
export const InviteAdvisorDialog_InviteAdvisorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InviteAdvisorDialog_inviteAdvisor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersRoleEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteAdvisor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteAdvisorDialog_InviteAdvisorMutation,
  InviteAdvisorDialog_InviteAdvisorMutationVariables
>
export const InviteClientDialog_InviteClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InviteClientDialog_inviteClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteClientDialog_InviteClientMutation,
  InviteClientDialog_InviteClientMutationVariables
>
export const MatchLevelDialog_CheckFitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MatchLevelDialog_checkFit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amIAGoodFit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'overallSummary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'overallMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantEducationMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantExperience' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantExperienceMatch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantSkills' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantSkillsMatch' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MatchLevelDialog_CheckFitMutation,
  MatchLevelDialog_CheckFitMutationVariables
>
export const NewApplicationDialog_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewApplicationDialog_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewApplicationDialog_ResumesQuery,
  NewApplicationDialog_ResumesQueryVariables
>
export const NewApplicationDialog_CreateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewApplicationDialog_createUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationInstructions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contact' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactsInputObject' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsPayPeriodEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsRejectedStageEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsInterviewStepEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationInstructions' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applicationInstructions' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contact' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contact' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isRemote' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'location' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payPeriod' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMax' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyDomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rejectedStage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewStep' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewApplicationDialog_CreateUsersJobMutation,
  NewApplicationDialog_CreateUsersJobMutationVariables
>
export const NewApplicationsDialog_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewApplicationsDialog_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'id' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewApplicationsDialog_UsersJobsQuery,
  NewApplicationsDialog_UsersJobsQueryVariables
>
export const NewApplicationsDialog_UpdateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewApplicationsDialog_updateUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsRejectedStageEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsInterviewStepEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsPayPeriodEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationInstructions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isRemote' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRemote' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'location' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMax' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMax' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'salaryMin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'salaryMin' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rejectedStage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rejectedStage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewStep' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewStep' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payPeriod' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payPeriod' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationInstructions' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applicationInstructions' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyDomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyDomain' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewApplicationsDialog_UpdateUsersJobMutation,
  NewApplicationsDialog_UpdateUsersJobMutationVariables
>
export const NewCoverLetterDialog_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewCoverLetterDialog_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverLetter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewCoverLetterDialog_UsersJobsQuery,
  NewCoverLetterDialog_UsersJobsQueryVariables
>
export const NewCoverLetterDialog_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewCoverLetterDialog_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewCoverLetterDialog_ResumesQuery,
  NewCoverLetterDialog_ResumesQueryVariables
>
export const NewCoverLetterDialog_CreateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewCoverLetterDialog_createUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewCoverLetterDialog_CreateUsersJobMutation,
  NewCoverLetterDialog_CreateUsersJobMutationVariables
>
export const NewCoverLetterDialog_CoverLetterUpsertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewCoverLetterDialog_coverLetterUpsert' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UsersJobsCoverLetterInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetterUpsert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoverLetter' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoverLetter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UsersJobsCoverLetterType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLocation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentUsedResumeForGenerate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewCoverLetterDialog_CoverLetterUpsertMutation,
  NewCoverLetterDialog_CoverLetterUpsertMutationVariables
>
export const NewHeadshotDialog_CreateHeadshotRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewHeadshotDialog_createHeadshotRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attire' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HeadshotRequestsAttireEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'background' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HeadshotRequestsBackgroundEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHeadshotRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attire' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attire' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'background' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'background' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewHeadshotDialog_CreateHeadshotRequestMutation,
  NewHeadshotDialog_CreateHeadshotRequestMutationVariables
>
export const NewInterviewDialog_ResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewInterviewDialog_resume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewInterviewDialog_ResumeQuery,
  NewInterviewDialog_ResumeQueryVariables
>
export const NewInterviewDialog_InterviewStartMockDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewInterviewDialog_interviewStartMock' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDescription' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interviewType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InterviewsTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviewStartMock' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDescription' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDescription' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interviewType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interviewType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewInterviewDialog_InterviewStartMockMutation,
  NewInterviewDialog_InterviewStartMockMutationVariables
>
export const NewResumeDialog_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewResumeDialog_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewResumeDialog_ResumesQuery, NewResumeDialog_ResumesQueryVariables>
export const NewResumeDialog_PaginatedResumeExamplesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewResumeDialog_paginatedResumeExamples' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedResumeExamples' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameSlug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exampleImageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewResumeDialog_PaginatedResumeExamplesQuery,
  NewResumeDialog_PaginatedResumeExamplesQueryVariables
>
export const NewResumeDialog_ResumeExampleCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewResumeDialog_resumeExampleCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'resumeExampleCategories' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  NewResumeDialog_ResumeExampleCategoriesQuery,
  NewResumeDialog_ResumeExampleCategoriesQueryVariables
>
export const NewResumeDialog_ResumeExampleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewResumeDialog_resumeExample' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nameSlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeExample' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nameSlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nameSlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nameSlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exampleImageUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewResumeDialog_ResumeExampleQuery,
  NewResumeDialog_ResumeExampleQueryVariables
>
export const NewResumeDialog_CreateResumeFromLinkedinUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewResumeDialog_createResumeFromLinkedinUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResumeFromLinkedinUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'linkedinProfileUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'linkedinProfileUrl' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewResumeDialog_CreateResumeFromLinkedinUrlMutation,
  NewResumeDialog_CreateResumeFromLinkedinUrlMutationVariables
>
export const NewResumeDialog_DuplicateFromResumeExampleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewResumeDialog_DuplicateFromResumeExample' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateResumeFromResumeExample' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewResumeDialog_DuplicateFromResumeExampleMutation,
  NewResumeDialog_DuplicateFromResumeExampleMutationVariables
>
export const RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RedeemCodeDialog_subscriptionsRedeemLtdPromoCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'promoCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionsRedeemLtdPromoCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'promoCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'promoCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutation,
  RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutationVariables
>
export const RequestResumeReviewDialog_RequestResumeReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestResumeReviewDialog_requestResumeReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestResumeReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestResumeReviewDialog_RequestResumeReviewMutation,
  RequestResumeReviewDialog_RequestResumeReviewMutationVariables
>
export const ShareJobPostingDialog_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareJobPostingDialog_usersJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientsShared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShareJobPostingDialog_UsersJobsQuery,
  ShareJobPostingDialog_UsersJobsQueryVariables
>
export const ShareJobPostingDialog_ClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareJobPostingDialog_clients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'IntValue', value: '50' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShareJobPostingDialog_ClientsQuery,
  ShareJobPostingDialog_ClientsQueryVariables
>
export const ShareJobPostingDialog_ClientGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareJobPostingDialog_clientGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShareJobPostingDialog_ClientGroupsQuery,
  ShareJobPostingDialog_ClientGroupsQueryVariables
>
export const ShareJobPostingDialog_ShareJobWithClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ShareJobPostingDialog_shareJobWithClients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shareJobWithClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShareJobPostingDialog_ShareJobWithClientsMutation,
  ShareJobPostingDialog_ShareJobWithClientsMutationVariables
>
export const ShareResumeDialog_UpdatePublicResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ShareResumeDialog_updatePublicResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isPublic' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePublicResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isPublic' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isPublic' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShareResumeDialog_UpdatePublicResumeMutation,
  ShareResumeDialog_UpdatePublicResumeMutationVariables
>
export const TailorResumeDialog_CreateUsersJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TailorResumeDialog_createUsersJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'position' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobDetails' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersJobs' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersJobs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobs' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectedStage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interviewStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numClientsShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerArchived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checklist' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checklistEnum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerCreatedByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resume' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TailorResumeDialog_CreateUsersJobMutation,
  TailorResumeDialog_CreateUsersJobMutationVariables
>
export const TailorResumeDialog_OptimizeResumeForJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TailorResumeDialog_optimizeResumeForJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skills' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimizeResumeForJobV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skills' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skills' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TailorResumeDialog_OptimizeResumeForJobMutation,
  TailorResumeDialog_OptimizeResumeForJobMutationVariables
>
export const TailorResumeDialog_FetchJobKeywordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TailorResumeDialog_fetchJobKeywords' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJobKeywords' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TailorResumeDialog_FetchJobKeywordsMutation,
  TailorResumeDialog_FetchJobKeywordsMutationVariables
>
export const TailorResumeDialog_FetchMissingSkillsOfJobResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TailorResumeDialog_fetchMissingSkillsOfJobResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchMissingSkillsOfJobResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TailorResumeDialog_FetchMissingSkillsOfJobResumeMutation,
  TailorResumeDialog_FetchMissingSkillsOfJobResumeMutationVariables
>
export const EnhanceAchievementDialog_GenerateOneJobAchievementFromStringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnhanceAchievementDialog_generateOneJobAchievementFromString' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'achievementStrings' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateJobAchievementFromString' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'achievementStrings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'achievementStrings' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutation,
  EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutationVariables
>
export const ResumeTemplateDrawer_UpdateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeTemplateDrawer_updateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'template' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesTemplateEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateColorEnum' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesTemplateColorEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTemplateResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'template' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'template' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateColorEnum' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateColorEnum' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeTemplateDrawer_UpdateTemplateMutation,
  ResumeTemplateDrawer_UpdateTemplateMutationVariables
>
export const AdvisorSheet_ClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdvisorSheet_clients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'advisorIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'advisorIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'advisorIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdvisorSheet_ClientsQuery, AdvisorSheet_ClientsQueryVariables>
export const AdvisorSheet_AssignClientToAdvisorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdvisorSheet_assignClientToAdvisor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'advisorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignClientToAdvisor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'advisorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'advisorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdvisorSheet_AssignClientToAdvisorMutation,
  AdvisorSheet_AssignClientToAdvisorMutationVariables
>
export const ApplicationToolbar_UsersJobsArchivedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationToolbar_usersJobsArchived' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'usersJobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'usersJobIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationToolbar_UsersJobsArchivedQuery,
  ApplicationToolbar_UsersJobsArchivedQueryVariables
>
export const ApplicationToolbar_UpdateUsersJobArchiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicationToolbar_updateUsersJobArchive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archive' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archive' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationToolbar_UpdateUsersJobArchiveMutation,
  ApplicationToolbar_UpdateUsersJobArchiveMutationVariables
>
export const BoardToolbar_UsersJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BoardToolbar_UsersJobs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersJobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoardToolbar_UsersJobsQuery, BoardToolbar_UsersJobsQueryVariables>
export const ClientBoardToolbar_ClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientBoardToolbar_client' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientBoardToolbar_ClientQuery,
  ClientBoardToolbar_ClientQueryVariables
>
export const ClientGroupToolbar_ClientGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientGroupToolbar_ClientGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientGroupIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'clientGroupId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientGroupToolbar_ClientGroupQuery,
  ClientGroupToolbar_ClientGroupQueryVariables
>
export const ClientResumeToolbar_ClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientResumeToolbar_client' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientResumeToolbar_ClientQuery,
  ClientResumeToolbar_ClientQueryVariables
>
export const ClientToolbar_ClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientToolbar_client' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientToolbar_ClientQuery, ClientToolbar_ClientQueryVariables>
export const ClientsToolbar_AdvisorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientsToolbar_advisors' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'advisors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'IntValue', value: '999999' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientsToolbar_AdvisorsQuery, ClientsToolbar_AdvisorsQueryVariables>
export const CoverLetterToolbar_CoverLettersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoverLetterToolbar_coverLetters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coverLetterIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'position' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLetterToolbar_CoverLettersQuery,
  CoverLetterToolbar_CoverLettersQueryVariables
>
export const CoverLetterToolbar_UpdateArchivedCoverLetterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CoverLetterToolbar_updateArchivedCoverLetter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateArchivedCoverLetter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coverLetterId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'coverLetterId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLetterToolbar_UpdateArchivedCoverLetterMutation,
  CoverLetterToolbar_UpdateArchivedCoverLetterMutationVariables
>
export const CoverLettersToolbar_CoverLettersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoverLettersToolbar_coverLetters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverLetters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CoverLettersToolbar_CoverLettersQuery,
  CoverLettersToolbar_CoverLettersQueryVariables
>
export const HeadshotsToolbar_HeadshotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeadshotsToolbar_headshots' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headshotRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HeadshotsToolbar_HeadshotsQuery,
  HeadshotsToolbar_HeadshotsQueryVariables
>
export const InterviewsToolbar_InterviewsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InterviewsToolbar_interviews' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interviews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InterviewsToolbar_InterviewsQuery,
  InterviewsToolbar_InterviewsQueryVariables
>
export const JobPostingsToolbar_ExportCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobPostingsToolbar_exportCsv' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'exportUsersJobToCsv' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  JobPostingsToolbar_ExportCsvMutation,
  JobPostingsToolbar_ExportCsvMutationVariables
>
export const ResumeBuilderToolbar_ArchiveResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderToolbar_archiveResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateArchivedResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderToolbar_ArchiveResumeMutation,
  ResumeBuilderToolbar_ArchiveResumeMutationVariables
>
export const ResumeBuilderToolbar_GetResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeBuilderToolbar_getResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'id' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderToolbar_GetResumeQuery,
  ResumeBuilderToolbar_GetResumeQueryVariables
>
export const ResumesToolbar_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumesToolbar_resumes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archived' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesToolbar_ResumesQuery, ResumesToolbar_ResumesQueryVariables>
export const UserNotificationsForm_JobSearchPreferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobSearchPreference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserNotificationsForm_JobSearchPreferenceQuery,
  UserNotificationsForm_JobSearchPreferenceQueryVariables
>
export const UserNotificationsForm_UpsertJobSearchPreferenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserNotificationsForm_UpsertJobSearchPreference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobSearchPreferenceInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpsertJobSearchPreference' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserNotificationsForm_JobSearchPreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobSearchPreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'locations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'educationRequirement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserNotificationsForm_UpsertJobSearchPreferenceMutation,
  UserNotificationsForm_UpsertJobSearchPreferenceMutationVariables
>
export const CreateResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateResumeMutation, CreateResumeMutationVariables>
export const ProviderAuthenticationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ProviderAuthentication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthProviderTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referredByUserUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeNameSlug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authProviderAuthenticate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeUniqueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referredByUserUniqueId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'referredByUserUniqueId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'utmSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeNameSlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeNameSlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProviderAuthenticationMutation,
  ProviderAuthenticationMutationVariables
>
export const CredentialsAuthenticationSignInDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationSignIn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authSignIn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationSignInMutation,
  CredentialsAuthenticationSignInMutationVariables
>
export const CredentialsAuthenticationSignUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationSignUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referredByUserUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeNameSlug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authSignUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referredByUserUniqueId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'referredByUserUniqueId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeUniqueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'utmSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'utmSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeNameSlug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeNameSlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationSignUpMutation,
  CredentialsAuthenticationSignUpMutationVariables
>
export const CredentialsAuthenticationEmailVerifyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationEmailVerify' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userEmailVerify' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailVerificationCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNewUser' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationEmailVerifyMutation,
  CredentialsAuthenticationEmailVerifyMutationVariables
>
export const ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumesQuery, ResumesQueryVariables>
export const RootDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Root' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAllChecklistItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RootQuery, RootQueryVariables>
export const UploadResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadResumeMutation, UploadResumeMutationVariables>
export const UseBillingPlan_SubscriptionSessionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'useBillingPlan_subscriptionSessionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'plan' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionPlanEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coupon' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isCreatedFromOnboarding' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionsSessionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'plan' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'plan' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coupon' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'coupon' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isOnboarding' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isCreatedFromOnboarding' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UseBillingPlan_SubscriptionSessionCreateMutation,
  UseBillingPlan_SubscriptionSessionCreateMutationVariables
>
export const UseBillingPlan_BillingPortalUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'useBillingPlan_billingPortalUrl' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'billingPortalUrl' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  UseBillingPlan_BillingPortalUrlMutation,
  UseBillingPlan_BillingPortalUrlMutationVariables
>
export const UseBrowserExtensionToast_UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'useBrowserExtensionToast_user' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UseBrowserExtensionToast_UserQuery,
  UseBrowserExtensionToast_UserQueryVariables
>
export const UseCreateResume_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'useCreateResume_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseCreateResume_ResumesQuery, UseCreateResume_ResumesQueryVariables>
export const UseCurrentUser_UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'useCurrentUser_users' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Users' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Users' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activeResumesCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coverLetterCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedResumeTour' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeSummaryCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resumeJobAchievementCustomPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenCoverLetter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenDownloadPdfs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterviewQuestions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenJobMatch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenProfessionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenSalaryInsights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenLearnSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenAchievements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenInterview' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenWriter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenOptimizeResume' } },
          { kind: 'Field', name: { kind: 'Name', value: 'usedChromeExtension' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numUploadedResumes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numStartedInterviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralTokens' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSubscription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAdvisoryOrgAccount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'profilePictureUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'writingStyleEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasSeenGoldOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobExperienceLevel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseCurrentUser_UsersQuery, UseCurrentUser_UsersQueryVariables>
export const UseUploadResume_ResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'useUploadResume_resumes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseUploadResume_ResumesQuery, UseUploadResume_ResumesQueryVariables>
export const UseUploadResume_RecentResumeUploadedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'useUploadResume_recentResumeUploaded' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeRecentUploaded' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UseUploadResume_RecentResumeUploadedMutation,
  UseUploadResume_RecentResumeUploadedMutationVariables
>
export const JobDetailsCard_CheckMatchLevelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobDetailsCard_checkMatchLevel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amIAGoodFit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'overallMatch' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobDetailsCard_CheckMatchLevelMutation,
  JobDetailsCard_CheckMatchLevelMutationVariables
>
export const JobDetailsContainer_GetJobListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobDetailsContainer_getJobListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListingsDetails' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasAddedJobListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRemote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salaryCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListingsDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobListings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiCoreResponsibilities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiWorkArrangement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiEducationRequirements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiRequirementsSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'benefits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyDomain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyIndustry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployees' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companySpecialties' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLinkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyLogoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keySkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workingHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelString' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hiringManagerName' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobListings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobDetailsContainer_GetJobListingQuery,
  JobDetailsContainer_GetJobListingQueryVariables
>
export const JobDetailsContainer_AddJobListingToBookmarksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobDetailsContainer_addJobListingToBookmarks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersJobsStatusEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookmarkJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobListingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobListingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobDetailsContainer_AddJobListingToBookmarksMutation,
  JobDetailsContainer_AddJobListingToBookmarksMutationVariables
>
export const JobSearchBar_CreateSearchFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobSearchBar_createSearchFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilters' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobListingsFilterInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSearchFilter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchFilters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchFilters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'educationRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'keywordOr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxonomies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'useCityStateForLocation' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePostedMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePostedMax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'foundedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobSearchBar_CreateSearchFilterMutation,
  JobSearchBar_CreateSearchFilterMutationVariables
>
export const JobSearchBar_UpdateSearchFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JobSearchBar_updateSearchFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilters' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JobListingsFilterInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSearchFilter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchFilters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchFilters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumEmployeesMax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'educationRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'keywordOr' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxonomies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMax' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'useCityStateForLocation' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePostedMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'datePostedMax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'foundedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobSearchBar_UpdateSearchFilterMutation,
  JobSearchBar_UpdateSearchFilterMutationVariables
>
export const LocationSearchInput_LocationsTypeaheadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationSearchInput_locationsTypeahead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationsTypeahead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'location' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LocationSearchInput_LocationsTypeaheadQuery,
  LocationSearchInput_LocationsTypeaheadQueryVariables
>
export const LocationSearchInput_UserStoreLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LocationSearchInput_userStoreLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userStoreLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'city' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LocationSearchInput_UserStoreLocationMutation,
  LocationSearchInput_UserStoreLocationMutationVariables
>
export const SavedFilters_SavedFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SavedFilters_savedFilters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jobListingSavedSearches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchFilters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'positions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyNumEmployeesMin' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyNumEmployeesMax' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'employmentTypes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workArrangements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'experienceLevels' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'educationRequirements' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'keywordOr' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'taxonomies' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'experienceLevelMax' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'locations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'useCityStateForLocation' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'radius' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'datePosted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'datePostedMin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'datePostedMax' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'foundedDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'salaryMin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'payPeriod' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'visaSponsorship' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavedFilters_SavedFiltersQuery,
  SavedFilters_SavedFiltersQueryVariables
>
export const ResumeBuilderV2_UpdateResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderV2_updateResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesInputObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderV2_UpdateResumeMutation,
  ResumeBuilderV2_UpdateResumeMutationVariables
>
export const ResumeBuilderV2_UpdateResumePreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderV2_updateResumePreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResumePreferencesInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResumePreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderV2_UpdateResumePreferencesMutation,
  ResumeBuilderV2_UpdateResumePreferencesMutationVariables
>
export const ResumeBuilderV2_UpdateResumeTourCompletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderV2_updateResumeTourCompleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasCompletedResumeTour' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasCompletedResumeTour' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'hasCompletedResumeTour' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderV2_UpdateResumeTourCompletedMutation,
  ResumeBuilderV2_UpdateResumeTourCompletedMutationVariables
>
export const ResumeBuilderV2_ScoreResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderV2_scoreResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scoreResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scoreFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'didPass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tagName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagLink' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderV2_ScoreResumeMutation,
  ResumeBuilderV2_ScoreResumeMutationVariables
>
export const ResumeBuilderV2_DownloadPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilderV2_downloadPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'downloadPdfResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilderV2_DownloadPdfMutation,
  ResumeBuilderV2_DownloadPdfMutationVariables
>
export const ViewerPanel_UpdateResumePdfBlobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ViewerPanel_updateResumePdfBlob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pdfBlob' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePdfBlob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pdfBlob' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pdfBlob' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewerPanel_UpdateResumePdfBlobMutation,
  ViewerPanel_UpdateResumePdfBlobMutationVariables
>
export const GenerateAchievementsMenu_GenerateOneJobAchievementFromStringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateAchievementsMenu_generateOneJobAchievementFromString' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'achievementStrings' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateJobAchievementFromString' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'achievementStrings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'achievementStrings' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutation,
  GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutationVariables
>
export const GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateProfessionalSummaryMenu_generateProfessionalSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useExisting' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateProfessionalSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useExisting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useExisting' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customPrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customPrompt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutation,
  GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutationVariables
>
export const ResumeAnalyzerToolkitSection_AnalyzeResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeAnalyzerToolkitSection_analyzeResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeRelevanceAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'jobTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jobTitle' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'irrelevantSkillsForJobTitle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skill' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'irrelevantAchievementsForJobTitle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'achievementIndex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievementType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievementTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'irrelevantAchievementForJobTitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relevantAchievementForJobTitle' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSummaryRelevantForJobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relevantSummaryForJobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkillsForJobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'originalSummary' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeAnalyzerToolkitSection_AnalyzeResumeMutation,
  ResumeAnalyzerToolkitSection_AnalyzeResumeMutationVariables
>
export const ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeAnalyzerToolkitSection_fixFromRelevanceAnalysis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'achievementsToUpdate' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ResumesRelevantAchievementInputObject' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skillsToAdd' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skillsToRemove' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ResumesAnalysisSkillTypeInputObject' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixFromRelevanceAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'achievementsToUpdate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'achievementsToUpdate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skillsToAdd' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skillsToAdd' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skillsToRemove' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skillsToRemove' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'summary' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workPositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupedSkills' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutation,
  ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutationVariables
>
export const ResumeAnalyzerToolkitSection_GetResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeAnalyzerToolkitSection_getResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeID' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'resumeID' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastAnalyzedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeAnalyzerToolkitSection_GetResumeQuery,
  ResumeAnalyzerToolkitSection_GetResumeQueryVariables
>
export const ResumeScorerTookitSection_ScoreResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeScorerTookitSection_scoreResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scoreResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scoreFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'didPass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tagName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagLink' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeScorerTookitSection_ScoreResumeMutation,
  ResumeScorerTookitSection_ScoreResumeMutationVariables
>
export const ResumeBuilder_GetResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeBuilder_getResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumeBuilder_GetResumeQuery, ResumeBuilder_GetResumeQueryVariables>
export const ResumeBuilder_GetResumeUnauthenticatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeBuilder_getResumeUnauthenticated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeUnauthenticated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_GetResumeUnauthenticatedQuery,
  ResumeBuilder_GetResumeUnauthenticatedQueryVariables
>
export const ResumeBuilder_GetClientResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeBuilder_getClientResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientResumes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_GetClientResumeQuery,
  ResumeBuilder_GetClientResumeQueryVariables
>
export const ResumeBuilder_PublicResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResumeBuilder_publicResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'publicId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'publicId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_PublicResumeQuery,
  ResumeBuilder_PublicResumeQueryVariables
>
export const ResumeBuilder_CreateResumeUnauthenticatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilder_createResumeUnauthenticated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesInputObject' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResumeUnauthenticated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_CreateResumeUnauthenticatedMutation,
  ResumeBuilder_CreateResumeUnauthenticatedMutationVariables
>
export const ResumeBuilder_UpdateResumeUnauthenticatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilder_updateResumeUnauthenticated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesInputObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResumeUnauthenticated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_UpdateResumeUnauthenticatedMutation,
  ResumeBuilder_UpdateResumeUnauthenticatedMutationVariables
>
export const ResumeBuilder_UpdateResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilder_updateResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesInputObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resumes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResumesPreferences' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumesPreferences' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verticalMargin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineHeight' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionTitleCasing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrderWithCustomSections' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePictureShape' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Resumes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resumes' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionalSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showOriginalDocument' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideEducations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideProjects' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSkills' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideSummary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCertifications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideWorkExperiences' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideCourseworks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideInvolvements' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideTargetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionsOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateColorEnum' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aiGenerated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResumesPreferences' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courseworks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnCourse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpa' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyInEducation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'involvements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnInvolvement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projects' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentlyWorkingOnProject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workExperiences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleAnalysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInPosition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'simpleAnalysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupedSkills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skills' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completionDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyCompletionDate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customSectionExperiences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'achievements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentlyInExperience' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showYearOnlyStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tokenResumeAnalysis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_UpdateResumeMutation,
  ResumeBuilder_UpdateResumeMutationVariables
>
export const ResumeBuilder_DownloadPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilder_downloadPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'downloadPdfResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_DownloadPdfMutation,
  ResumeBuilder_DownloadPdfMutationVariables
>
export const ResumeBuilder_ScoreResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeBuilder_scoreResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scoreResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scoreFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'didPass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tagName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagLink' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeBuilder_ScoreResumeMutation,
  ResumeBuilder_ScoreResumeMutationVariables
>
export const Plan_SubscriptionSessionFetchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Plan_subscriptionSessionFetch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionsSessionFetch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Plan_SubscriptionSessionFetchMutation,
  Plan_SubscriptionSessionFetchMutationVariables
>
export const Plan_CompleteOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Plan_completeOnboarding' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hasCompletedOnboarding' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompletedOnboarding' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Plan_CompleteOnboardingMutation,
  Plan_CompleteOnboardingMutationVariables
>
export const Plan_RequestResumeSuccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Plan_requestResumeSuccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionsRequestResumeSuccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Plan_RequestResumeSuccessMutation,
  Plan_RequestResumeSuccessMutationVariables
>
